<template>

  <div class="py-4 container-fluid">
    <div class="row oven-panels-row align-items-stretch">

      <div class="col-md-8 d-flex min-h-0">
        <div class="card mb-2 w-100">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <span class="section-title">CREAR QUEMA EN HORNO</span>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Consecutivo Horno</label>
                <argon-input type="text" v-model="form.consecutive" />
              </div>
              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Consecutivo secado</label>
                <argon-input type="text" v-model="form.consecutivo_secado" />
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="amount" class="form-label">Horno</label>
                  <select ref="modelSelect" id="models" class="form-select select2" style="width:100%;">
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Numero de quema</label>
                <argon-input type="number" v-model="form.burn_number" />
              </div>

              <!--  
              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Descripción</label>
                <ArgonTextarea type="text" v-model="form.description" />
              </div>
              -->
              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Fecha de inicio</label>
                <argon-input type="date" v-model="form.started_at" />
              </div>
              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Fecha estimada de entrega</label>
                <argon-input type="date" v-model="form.estimated_at" />
              </div>

              <div class="col-md-6" v-if="form.id != 0">
                <label for="example-text-input" class="form-control-label">Estado</label>
                <select name="" id="" class="form-select" v-model="form.status" @change="handleStatusChange" :disabled="form.status == 2">
                  <option value="0" v-if="form.status<1">Pendiente</option>
                  <option value="1">Activo</option>
                  <option value="2">Terminado</option>
                </select>
              </div>
              <div class="col-md-6 d-flex align-items-end justify-content-end" v-if="form.id != 0">
                <argon-button color="warning" size="sm" v-if="form.status < 2" @click="save">Guardar</argon-button>
              </div>
              <div class="col-12 d-flex align-items-end justify-content-end" v-else>
                <argon-button color="warning" size="sm" v-if="form.status < 2" @click="save">Guardar</argon-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Panel QUEMAS EN HORNO: misma altura que CREAR QUEMA, scroll cuando no caben todas las tarjetas -->
      <div class="col-md-4 d-flex oven-quemas-col min-h-0" v-if="form.id != 0">
        <div class="card mb-2 w-100 d-flex flex-column oven-quemas-card min-h-0">
          <div class="card-header flex-shrink-0">
            <div class="d-flex align-items-center">
              <span class="section-title">QUEMAS EN HORNO</span>
              <argon-button color="warning" size="sm" class="ms-auto" v-if="form.status < 2"
                @click="openModalFurnace()">agregar</argon-button>
            </div>
          </div>
          <div class="card-body pt-0 flex-grow-1 overflow-auto min-h-0 oven-quemas-body">
            <div class="d-flex flex-column gap-2">
              <div v-for="furnace in furnaces" :key="furnace.id" class="card border position-relative p-3"
                style="box-shadow: 0 1px 3px rgba(0,0,0,0.1);">

                <!-- Línea superior: Quema (izq) y Fecha + eliminar (der) -->
                <div class="d-flex justify-content-between align-items-center mb-2 pt-1" style="font-size: 0.75rem;">
                  <span>
                    <span class="furnace-card-label-inline me-2">Quema:</span>
                    <span class="furnace-card-value">{{ getFurnaceBurnHours(furnace) }} horas</span>
                  </span>
                  <div class="d-flex align-items-center gap-2">
                    <span class="furnace-card-value">
                      {{ isValidDate(furnace.updated_at) ? new Date(furnace.updated_at).toLocaleDateString('es-ES') : 'Sin asignar' }}
                    </span>
                    <a @click="deleteFurnace(furnace.id)" class="text-danger" style="cursor: pointer;">
                      <i class="fa fa-trash"></i>
                    </a>
                  </div>
                </div>

                <!-- Información principal -->
                <div class="pe-3 furnace-card-info">
                  <!-- Fila 1: Patio (P.Carbon: valor) y P1: valor en la misma línea -->
                  <div class="furnace-card-grid mb-1" style="font-size: 0.75rem;">
                    <div class="d-flex align-items-center furnace-card-grid-cell">
                      <i class="fa fa-fire text-warning me-1" style="font-size: 0.75rem;"></i>
                      <span class="furnace-card-sublabel furnace-card-label-inline">P.Carbon:</span>
                      <span class="furnace-card-value ms-1">{{ furnace.patio_carbon }}</span>
                    </div>
                    <div class="d-flex align-items-center furnace-card-grid-cell">
                      <i class="fa fa-tint text-info me-1" style="font-size: 0.75rem;"></i>
                      <span class="furnace-card-sublabel furnace-card-label-inline">P1:</span>
                      <span class="furnace-card-value ms-1">{{ furnace.water_absorption }}%</span>
                    </div>
                  </div>
                  <!-- Fila 2: Carbon (debajo de patio) y P2 en la misma línea -->
                  <div class="furnace-card-grid mb-1" style="font-size: 0.75rem;">
                    <div class="d-flex align-items-center furnace-card-grid-cell">
                      <span class="furnace-card-sublabel furnace-card-label-inline">Carbon(Ton):</span>
                      <span class="furnace-card-value ms-1">{{ furnace.carbon_quantity }}</span>
                    </div>
                    <div class="d-flex align-items-center furnace-card-grid-cell">
                      <i class="fa fa-tint text-info me-1" style="font-size: 0.75rem;"></i>
                      <span class="furnace-card-sublabel furnace-card-label-inline">P2:</span>
                      <span class="furnace-card-value ms-1">{{ furnace.water_absorption_2 }}%</span>
                    </div>
                  </div>

                  <div class="d-flex align-items-center mb-1 furnace-card-row" style="font-size: 0.75rem;">
                    <span class="furnace-card-label-inline furnace-card-label-fixed">Inicio:</span>
                    <span class="d-flex align-items-center furnace-card-value">
                      <i class="fa fa-calendar text-success me-1" style="font-size: 0.65rem;"></i>
                      <span>{{ furnace.start_date }}</span>
                      <i class="fa fa-clock text-success ms-2 me-1" style="font-size: 0.65rem;"></i>
                      <span>{{ furnace.start_time }}</span>
                    </span>
                  </div>

                  <div class="d-flex align-items-center mb-1 furnace-card-row" style="font-size: 0.75rem;">
                    <span class="furnace-card-label-inline furnace-card-label-fixed">Finalizado:</span>
                    <span class="d-flex align-items-center furnace-card-value">
                      <i class="fa fa-calendar text-danger me-1" style="font-size: 0.65rem;"></i>
                      <span>{{ furnace.end_date }}</span>
                      <i class="fa fa-clock text-danger ms-2 me-1" style="font-size: 0.65rem;"></i>
                      <span>{{ furnace.end_time }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Estado vacío -->
            <div v-if="furnaces.length === 0" class="text-center py-3 text-muted">
              <i class="fa fa-fire fa-2x mb-2 text-muted opacity-50"></i>
              <p class="mb-0" style="font-size: 0.85rem;">No hay quemas registradas</p>
            </div>
          </div>
        </div>
      </div>



      <div class="col-md-12" v-show="form.id != 0">

        <!-- Item 3 -->
        <div class="card mt-2">
          <div class="card-header d-flex justify-content-between align-items-center">
            <span class="section-title">CARGUE HORNO</span>
            <div class="d-flex align-items-center" style="gap: 10px;">
              <argon-button color="warning" size="sm" v-if="collapseOpen[2] && form.status==0" @click="openModalLoading()">
                Agregar cargue
              </argon-button>
              <template v-if="loadings.length > 0">
                <button
                  v-if="loadingKardexNeedsSync"
                  type="button"
                  class="btn btn-outline-secondary btn-sm m-0"
                  :disabled="syncingKardexLoading"
                  @click="syncKardexLoading"
                >
                  {{ syncingKardexLoading ? '…' : 'Sincronizar' }}
                </button>
                <span v-else class="text-xs text-secondary mb-0 font-weight-bold">{{ loadingKardexLabel }}</span>
              </template>
              <button class="btn btn-primary btn-sm m-0" @click="toggleCollapse(2)">
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div class="collapse" ref="collapse2">
            <div class="card-body">

              <div class="mb-2">

                <div class="row">

                  <div class="table-responsive p-0">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Opciones
                          </th>
                          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Modulo</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Cantidad
                          </th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Averia cargue</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Averia secado</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Cantidad total</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Ultima modificación</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="value in loadings" :key="value.id">

                          <td class="align-middle text-center">
                            <div class="d-flex align-items-center justify-content-center gap-2 flex-wrap">
                              <a @click="confirmLoading(value)"
                                class="text-secondary font-weight-bold text-xs cursor-pointer ml-3"
                                data-toggle="tooltip"
                                data-original-title="Clic para confirmar (no se podrá editar después)"
                                v-if="!value.confirmed">
                                <i class="fa fa-check"></i>
                              </a>

                              <span style="color: forestgreen;" v-if="value.confirmed">
                                <i class="fa fa-check"></i>
                              </span>

                              
                              <a v-if="form.status < 1 && !value.confirmed" @click="deleteLoadings(value.id)" style="margin-left: 15px;"
                                class="text-secondary font-weight-bold text-xs cursor-pointer"
                                data-toggle="tooltip" data-original-title="Eliminar registro">
                                <i class="fa fa-trash"></i>
                              </a>
                            </div>
                          </td>

                          <td>
                            <div class="d-flex px-2 py-1">
                              <div class="d-flex flex-column justify-content-center">
                                <h6 class="mb-0 text-sm">{{ value?.driying?.production?.model?.name }}</h6>
                              </div>
                            </div>
                          </td>
                          <td class="align-middle text-center">
                            <div class="text-secondary text-xs font-weight-bold">
                              {{ value?.quantity }}
                            </div>
                          </td>
                          <td class="align-middle text-center">
                            <input type="number" class="form-control form-control-sm text-center d-inline-block" style="width: 70px; min-width: 60px;"
                              v-model.number="value.averia_cargue"
                              @change="updateLoadingAverias(value)"
                              :disabled="!!value.confirmed"
                              min="0">
                          </td>
                          <td class="align-middle text-center">
                            <input type="number" class="form-control form-control-sm text-center d-inline-block" style="width: 70px; min-width: 60px;"
                              v-model.number="value.averia_secado"
                              @change="updateLoadingAverias(value)"
                              :disabled="!!value.confirmed"
                              min="0">
                          </td>
                          <td class="align-middle text-center">
                            <div class="text-secondary text-xs font-weight-bold">
                              {{ value?.total_quantity }}
                            </div>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">
                              {{ isValidDate(value.updated_at) ? new
                                Date(value.updated_at).toLocaleDateString('es-ES') :
                                'Sin asignar' }}
                            </span>
                          </td>




                        </tr>


                      </tbody>
                    </table>
                  </div>
                </div>
              </div>



              <div class="mb-2" v-if="form.id != 0">
                <div class="pb-0 d-flex align-items-center justify-content-between mb-3">
                  <span class="section-title">USUARIOS ASIGNADOS</span>
                  <div class="d-flex align-items-center" style="gap: 10px;">
                    <argon-button
                      v-if="hasAssignedUsers && selectedAssignedUserRows.length > 0 && selectedBaseAction === 'receive'"
                      color="info"
                      size="sm"
                      :disabled="form.status === 2"
                      @click="markSelectedReceived"
                    >
                      Inicio
                    </argon-button>
                    <argon-button
                      v-if="hasAssignedUsers && selectedAssignedUserRows.length > 0 && selectedBaseAction === 'deliver'"
                      color="primary"
                      size="sm"
                      :disabled="form.status === 2"
                      @click="markSelectedDelivered"
                    >
                      Entregar
                    </argon-button>
                    <argon-button
                      v-if="hasAssignedUsers && selectedAssignedUserRows.length > 0 && selectedBaseAction === 'validate'"
                      color="success"
                      size="sm"
                      :disabled="form.status === 2"
                      @click="markSelectedValidated"
                    >
                      Validar
                    </argon-button>
                    <argon-button color="warning" size="sm" v-if="form.status < 2" @click="openModal(3)">
                      Asignar usuarios
                    </argon-button>
                  </div>
                </div>

                <div class="row">

                  <div class="table-responsive p-0">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Opciones</th>
                          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Usuario
                          </th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cuadrilla
                          </th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Oficio
                          </th>
                          <!-- <th
                              class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Cant.
                              recibida</th>
                            <th
                              class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Cant.
                              entregada</th>
                            <th
                              class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Cant.
                              defectuosa</th> -->
                          <!--  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Fecha de asignación</th>
                            <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Fecha estimada entrega</th> -->
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Fecha Inicio</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Fecha Termino</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Fecha validado</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            observación</th>
                          <!--  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Total
                              ganancia</th> -->

                        </tr>
                      </thead>
                      <tbody v-if="data && data.data">
                        <tr v-for="value in data.data.filter(v => v.modulo === 3)" :key="value.id">
                          <td class="align-middle text-center">
                            <div
                              style="display: flex;justify-content: center; align-items: center;gap: 10px;height: 100%;">
                              <div class="custom-checkbox-wrapper-assigned" v-if="value.validated_date == null">
                                <input
                                  type="checkbox"
                                  class="custom-checkbox"
                                  :id="'checkbox-oven-' + value.id"
                                  :value="value.id"
                                  v-model="selectedOvenUserIds"
                                  :disabled="isAssignedUserCheckboxDisabled(value)"
                                />
                                <label :for="'checkbox-oven-' + value.id" class="custom-checkbox-label">
                                  <i class="fa fa-check"></i>
                                </label>
                              </div>

                              <span style="color: forestgreen;" v-if="value.validated_date != null">
                                <i class="fa fa-check"></i>
                              </span>

                              <a @click="deleteUserRegister(value.id)"
                                class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                                data-original-title="Eliminar registro" v-if="value.received_date == null && form.status !== 2">
                                <i class="fa fa-trash"></i>
                              </a>
                            </div>
                          </td>
                          <td>
                            <div class="d-flex px-2 py-1">
                              <div class="d-flex flex-column justify-content-center">
                                <h6 class="mb-0 text-sm">{{ value.user.name }}</h6>
                              </div>
                            </div>
                          </td>
                          <td class="align-middle text-center">
                            <div class="text-secondary text-xs font-weight-bold">
                              {{ getCuadrillaName(value) }}
                            </div>
                          </td>
                          <td class="align-middle text-center">
                            <div class="text-secondary text-xs font-weight-bold">
                              {{ value?.oficio?.name }}
                            </div>
                          </td>
                          
                          <!-- <td class="align-middle text-center">
                              {{ value.received_quantity }}
                            </td>
                            <td class="align-middle text-center">
                              {{ value.delivered_quantity }}
                            </td>
                            <td class="align-middle text-center">
                              {{ value.rejected_quantity }}
                            </td> -->
                          <!-- <td class="align-middle text-center">
                              <span class="text-secondary text-xs font-weight-bold">
                                {{ isValidDate(value.assigned_at) ? new
                                  Date(value.assigned_at).toLocaleDateString('es-ES') :
                                  'Sin asignar' }}
                              </span>
                            </td>
                            <td class="align-middle text-center">
                              <span class="text-secondary text-xs font-weight-bold">
                                {{ isValidDate(value.estimated_at) ? new
                                  Date(value.estimated_at).toLocaleDateString('es-ES') :
                                  'Sin asignar' }}
                              </span>
                            </td> -->
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">
                              {{ isValidDate(value.received_date) ? new
                                Date(value.received_date).toLocaleString('es-ES', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: true
                                }) : 'Sin asignar' }}
                            </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">
                              {{ isValidDate(value.delivered_date) ? new
                                Date(value.delivered_date).toLocaleString('es-ES', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: true
                                }) : 'Sin asignar' }}
                            </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">
                              {{ isValidDate(value.validated_date) ? new
                                Date(value.validated_date).toLocaleString('es-ES', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: true
                                }) : 'Sin asignar' }}
                            </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">
                              <a @click="viewObservation(value.observation)"
                                class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                                data-original-title="Registro">
                                <i class="fa fa-comment"></i>
                              </a>
                            </span>
                          </td>
                          <!-- <td class="align-middle text-center">
                              <span class="text-secondary text-xs font-weight-bold">
                                {{ parseFloat(value.total).toLocaleString('es-ES', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                }) }}
                              </span>
                            </td> -->


                        </tr>


                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- Item 4: visible cuando el estado es Activo o Terminado -->
        <div class="card mt-2" v-if="Number(form.status) === 1 || Number(form.status) === 2">
          <div class="card-header d-flex justify-content-between align-items-center">
            <span class="section-title">DESCARGUE</span>
            <div class="d-flex align-items-center" style="gap: 10px;">
              <argon-button color="warning" size="sm" v-if="collapseOpen[3] && form.status < 2" @click="openModalUnloading()">
                Agregar descargue
              </argon-button>
              <template v-if="unloadings.length > 0">
                <button
                  v-if="unloadingKardexNeedsSync"
                  type="button"
                  class="btn btn-outline-secondary btn-sm m-0"
                  :disabled="syncingKardexUnloading"
                  @click="syncKardexUnloading"
                >
                  {{ syncingKardexUnloading ? '…' : 'Sincronizar' }}
                </button>
                <span v-else class="text-xs text-secondary mb-0 font-weight-bold">{{ unloadingKardexLabel }}</span>
              </template>
              <button class="btn btn-primary btn-sm m-0" @click="toggleCollapse(3)">
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div class="collapse" ref="collapse3">
            <div class="card-body">


              <div class="mb-2">

                <div class="row">

                  <div class="table-responsive p-0">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" v-if="form.status < 2">
                            Opciones
                          </th>
                          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Modulo Cargue</th>
                          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Primera</th>
                          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Segunda
                          </th>
                          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Tercera
                          </th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Averia descargue</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Averia crudo</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Cantidad total</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Ultima modificación</th>

                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="value in unloadings" :key="value.id" >

                          <td class="align-middle text-center" v-if="form.status < 2">
                          
                            <a @click="checkDeliveredDrying(value)"
                              class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                              data-original-title="Eliminar registro" v-if="value.delivered_at == null">
                              <i class="fa fa-check"></i>
                            </a>

                            <span style="color: forestgreen;" v-if="value.delivered_at != null">
                              <i class="fa fa-check"></i>
                            </span>
                            
                            <a @click="deleteUnloadings(value.id)"
                              class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                              data-toggle="tooltip" data-original-title="Eliminar registro"
                              v-if="value.delivered_at==null">
                              <i class="fa fa-trash"></i>
                            </a>
                          </td>

                          <td>
                            <div class="d-flex px-2 py-1">
                              <div class="d-flex flex-column justify-content-center">
                                <h6 class="mb-0 text-sm">{{ value?.inventory?.name || "" }}
                                </h6>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="d-flex px-2 py-1">
                              <div class="d-flex flex-column justify-content-center">
                                <h6 class="mb-0 text-sm">{{ value?.primera }}</h6>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="d-flex px-2 py-1">
                              <div class="d-flex flex-column justify-content-center">
                                <h6 class="mb-0 text-sm">{{ value?.segunda }}</h6>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="d-flex px-2 py-1">
                              <div class="d-flex flex-column justify-content-center">
                                <h6 class="mb-0 text-sm">{{ value?.tercera }}</h6>
                              </div>
                            </div>
                          </td>
                          <td class="align-middle text-center">
                            <div class="text-secondary text-xs font-weight-bold">
                              {{ value?.averia_descargue }}
                            </div>
                          </td>
                          <td class="align-middle text-center">
                            <div class="text-secondary text-xs font-weight-bold">
                              {{ value?.averia_crudo }}
                            </div>
                          </td>
                          <td class="align-middle text-center">
                            <div class="text-secondary text-xs font-weight-bold">
                              {{ value?.total_quantity }}
                            </div>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">
                              {{ isValidDate(value.updated_at) ? new
                                Date(value.updated_at).toLocaleDateString('es-ES') :
                                'Sin asignar' }}
                            </span>
                          </td>




                        </tr>


                      </tbody>
                    </table>
                  </div>
                </div>
              </div>



              <div class="mb-2" v-if="form.id != 0">
                <div class="pb-0 d-flex align-items-center justify-content-between">
                  <span class="section-title">USUARIOS ASIGNADOS</span>
                  <div class="d-flex align-items-center" style="gap: 10px;">
                    <!-- Botones flujo trabajo en DESCARGUE -->
                    <argon-button
                      v-if="hasDescAssignedUsers && selectedDescAssignedUserRows.length > 0 && selectedDescBaseAction === 'receive'"
                      color="info"
                      size="sm"
                      :disabled="form.status === 2"
                      @click="markSelectedReceivedDesc"
                    >
                      Inicio
                    </argon-button>
                    <argon-button
                      v-if="hasDescAssignedUsers && selectedDescAssignedUserRows.length > 0 && selectedDescBaseAction === 'deliver'"
                      color="primary"
                      size="sm"
                      :disabled="form.status === 2"
                      @click="markSelectedDeliveredDesc"
                    >
                      Entregar
                    </argon-button>
                    <argon-button
                      v-if="hasDescAssignedUsers && selectedDescAssignedUserRows.length > 0 && selectedDescBaseAction === 'validate'"
                      color="success"
                      size="sm"
                      :disabled="form.status === 2"
                      @click="markSelectedValidatedDesc"
                    >
                      Validar
                    </argon-button>
                    <argon-button color="warning" size="sm" v-if="form.status < 2" @click="openModal(4)">
                      Asignar usuarios
                    </argon-button>
                  </div>
                </div>

                <div class="row">

                  <div class="table-responsive p-0">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Opciones</th>
                          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Usuario
                          </th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cuadrilla
                          </th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Oficio
                          </th>
                          <!-- <th
                              class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Cant.
                              recibida</th>
                            <th
                              class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Cant.
                              entregada</th>
                            <th
                              class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Cant.
                              defectuosa</th> -->
                          <!-- <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Fecha de asignación</th>
                            <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Fecha estimada entrega</th> -->
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Fecha Inicio</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Fecha Termino</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Fecha validado</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            observación</th>
                          <!--  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Total
                              ganancia</th> -->

                        </tr>
                      </thead>
                      <tbody v-if="data && data.data">
                        <tr v-for="value in data.data.filter(v => v.modulo === 4)" :key="value.id">
                          <td class="align-middle text-center">
                            <div
                              style="display: flex;justify-content: center; align-items: center;gap: 10px;height: 100%;">
                              <!-- Sin validar: checkbox para Inicio / Entregar / Validar (según estado) + eliminar si no tiene inicio -->
                              <template v-if="value.validated_date == null">
                                <div class="custom-checkbox-wrapper-assigned">
                                  <input
                                    type="checkbox"
                                    class="custom-checkbox"
                                    :id="'checkbox-oven-desc-' + value.id"
                                    :value="value.id"
                                    v-model="selectedOvenUserIds"
                                    :disabled="isAssignedUserCheckboxDisabledDesc(value)"
                                  />
                                  <label :for="'checkbox-oven-desc-' + value.id" class="custom-checkbox-label">
                                    <i class="fa fa-check"></i>
                                  </label>
                                </div>
                                <a @click="deleteUserRegister(value.id)"
                                  class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                                  data-original-title="Eliminar registro" v-if="value.received_date == null">
                                  <i class="fa fa-trash"></i>
                                </a>
                              </template>

                              <!-- Ya validado: solo check verde -->
                              <span v-else style="color: forestgreen;">
                                <i class="fa fa-check"></i>
                              </span>
                            </div>
                          </td>
                          <td>
                            <div class="d-flex px-2 py-1">
                              <div class="d-flex flex-column justify-content-center">
                                <h6 class="mb-0 text-sm">{{ value.user.name }}</h6>
                              </div>
                            </div>
                          </td>
                          <td class="align-middle text-center">
                            <div class="text-secondary text-xs font-weight-bold">
                              {{ getCuadrillaName(value) }}
                            </div>
                          </td>
                          <td class="align-middle text-center">
                            <div class="text-secondary text-xs font-weight-bold">
                              {{ value?.oficio?.name }}
                            </div>
                          </td>
                          
                          <!-- <td class="align-middle text-center">
                              {{ value.received_quantity }}
                            </td>
                            <td class="align-middle text-center">
                              {{ value.delivered_quantity }}
                            </td>
                            <td class="align-middle text-center">
                              {{ value.rejected_quantity }}
                            </td> -->
                          <!-- <td class="align-middle text-center">
                              <span class="text-secondary text-xs font-weight-bold">
                                {{ isValidDate(value.assigned_at) ? new
                                  Date(value.assigned_at).toLocaleDateString('es-ES') :
                                  'Sin asignar' }}
                              </span>
                            </td>
                            <td class="align-middle text-center">
                              <span class="text-secondary text-xs font-weight-bold">
                                {{ isValidDate(value.estimated_at) ? new
                                  Date(value.estimated_at).toLocaleDateString('es-ES') :
                                  'Sin asignar' }}
                              </span>
                            </td> -->
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">
                              {{ isValidDate(value.received_date) ? new
                                Date(value.received_date).toLocaleString('es-ES', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: true
                                }) : 'Sin asignar' }}
                            </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">
                              {{ isValidDate(value.delivered_date) ? new
                                Date(value.delivered_date).toLocaleString('es-ES', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: true
                                }) : 'Sin asignar' }}
                            </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">
                              {{ isValidDate(value.validated_date) ? new
                                Date(value.validated_date).toLocaleString('es-ES', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: true
                                }) : 'Sin asignar' }}
                            </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">
                              <a @click="viewObservation(value.observation)"
                                class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                                data-original-title="Registro">
                                <i class="fa fa-comment"></i>
                              </a>
                            </span>
                          </td>
                          <!-- <td class="align-middle text-center">
                              <span class="text-secondary text-xs font-weight-bold">
                                {{ parseFloat(value.total).toLocaleString('es-ES', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                }) }}
                              </span>
                            </td> -->


                        </tr>


                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>


    </div>





    <!-- Modal Asignar tecnico -->
    <div class="modal fade" id="ModalUsers" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog  modal-lg">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Asignar Usuarios</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form class="row">

              <div class="col-6 mb-3">
                <label for="amount" class="form-label">Oficio</label>
                <select ref="processesSelect" id="oficio" class="form-select select2" style="width:100%;">
                </select>
              </div>

              <div class="col-6 mb-3">
                <label for="example-text-input" class="form-control-label">Cuadrilla</label>
                <select ref="cuadrillaSelect" id="cuadrilla" class="form-select select2" style="width:100%;">
                  <option value="">Todas</option>
                  <option v-for="process in cuadrillas" :key="process.id" :value="process.id">
                    {{ process.name }}
                  </option>
                </select>
              </div>

              <div class="col-12 mb-3" v-if="production_user.oficio_id">
                <div class="d-flex align-items-center justify-content-between">
                  <label class="form-control-label mb-0">Buscar usuario</label>
                  <button type="button" class="btn btn-link p-0 text-secondary" @click="toggleUserSearch"
                    :aria-label="showUserSearch ? 'Ocultar buscador de usuarios' : 'Mostrar buscador de usuarios'">
                    <i class="fas fa-search" aria-hidden="true"></i>
                  </button>
                </div>
                <div v-if="showUserSearch" class="mt-2">
                  <input id="user-search" type="text" class="form-control" v-model.trim="userSearch"
                    placeholder="Escribe un nombre para filtrar..." autocomplete="off">
                </div>
              </div>

              <div class="col-12 mb-3" v-if="production_user.oficio_id && visibleUsers.length > 0">
                <label for="users-checkbox-list" class="form-label">Usuarios</label>
                <div id="users-checkbox-list" class="checkbox-grid">
                  <div v-for="user in visibleUsers" :key="user.id">
                    <argon-checkbox :id="'user-' + user.id" :value="user.id" v-model="production_user.user_id"
                      :checked="production_user.user_id.includes(user.id)">
                      {{ user.name }} - (Cuadrilla: {{ user.cuadrilla_name ?? "Sin asignar" }})
                    </argon-checkbox>

                  </div>
                </div>
              </div>

              <div class="col-12 mb-3" v-else-if="production_user.oficio_id && filteredUsers.length === 0">
                <p class="text-sm text-secondary mb-0 px-2">
                  {{ production_user.cuadrilla ? 'No hay usuarios para el oficio y la cuadrilla seleccionada.' : 'No hay usuarios para el oficio seleccionado.' }}
                </p>
              </div>

              <div class="col-12 mb-3"
                v-else-if="production_user.oficio_id && filteredUsers.length > 0 && visibleUsers.length === 0">
                <p class="text-sm text-secondary mb-0 px-2">
                  No hay usuarios que coincidan con la búsqueda.
                </p>
              </div>

            </form>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitForm" :disabled="isSubmittingAssignUsers">
              {{ isSubmittingAssignUsers ? 'Guardando...' : 'Guardar' }}
            </button>
          </div>
        </div>
      </div>
    </div>



    <!-- Modal cargue  -->
    <div class="modal fade" id="ModalLoading" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog  modal-lg">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title section-title" id="exampleModalLabel">Agregar registro de cargue</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row align-items-end">
              <div class="col-md-8">
                <div class="mb-3">
                  <label for="bodega_id_cargue" class="form-label">Modulo</label>
                  <select id="bodega_id_cargue" ref="moduloSelect" class="form-select" style="width: 100%;">
                    <option value="">Seleccionar material producción</option>
                  </select>
                </div>
              </div>
              <div class="col-md-4" v-show="selectedModel?.production?.model">
                <div class="mb-3">
                  <label for="cantidad_cargue" class="form-control-label">Cantidad</label>
                  <input type="number" class="form-control" id="cantidad_cargue" v-model="loading.quantity" min="0">
                </div>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalLoading">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="saveLoading">Guardar</button>
          </div>
        </div>
      </div>
    </div>



    <!-- Modal cargue  -->
    <div class="modal fade" id="ModalUnloading" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog  modal-lg">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Agregar registro de descargue</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="bodega_id_cargue" class="form-label">Material de cargue</label>
                  <select ref="selectUnloadingWarehouse" class="form-select" style="width:100%;">
                  </select>
                </div>
              </div>

              <div class="col-md-4" v-show="selectedModel.primera != '' && selectedModel.primera != null">
                <div class="mb-3">
                  <label for="cantidad_cargue" class="form-control-label">Primera</label>
                  <input type="number" class="form-control" id="primera" v-model="unloading.primera">
                </div>
                 <div class="mb-3">
                  <label for="modulo_primera" class="form-label select2">Modulo primera</label>
                  <select ref="moduloPrimera" id="modulo_primera" class="form-select" style="width: 100%;">
                  </select>
                </div>
              </div>

              <div class="col-md-4" v-show="selectedModel.segunda != '' && selectedModel.segunda != null">
                <div class="mb-3">
                  <label for="cantidad_cargue" class="form-control-label">Segunda</label>
                  <input type="number" class="form-control" id="segunda" v-model="unloading.segunda">
                </div>
                 <div class="mb-3">
                  <label for="modulo_segunda" class="form-label select2">Modulo segunda</label>
                  <select ref="moduloSegunda" id="modulo_segunda" class="form-select" style="width: 100%;">
                  </select>
                </div>
              </div>

              <div class="col-md-4" v-show="selectedModel.tercera != '' && selectedModel.tercera != null">
                <div class="mb-3">
                  <label for="cantidad_cargue" class="form-control-label">Tercera</label>
                  <input type="number" class="form-control" id="tercera" v-model="unloading.tercera">
                </div>
                <div class="mb-3">
                  <label for="modulo_tercera" class="form-label select2">Modulo tercera</label>
                  <select ref="moduloTercera" id="modulo_tercera" class="form-select" style="width: 100%;">
                  </select>
                </div>
              </div>
             

              <div class="col-md-4" v-show="selectedModel.averia_descargue != '' && selectedModel.averia_descargue != null">
                <div class="mb-3">
                  <label for="cantidad_averia_cargue" class="form-control-label">Averia en descargue</label>
                  <input type="number" class="form-control" id="cantidad_averia_cargue"
                    v-model="unloading.averia_descargue">
                </div>
              </div>

              <div class="col-md-4" v-show="selectedModel.averia_crudo != '' && selectedModel.averia_crudo != null">
                <div class="mb-3">
                  <label for="cantidad_averia_cargue" class="form-control-label">Averia en crudo</label>
                  <input type="number" class="form-control" id="cantidad_averia_cargue"
                    v-model="unloading.averia_crudo">
                </div>
              </div>

              <div class="col-md-4" v-show="selectedModel && selectedModel.id && selectedModel.id != 0">
                <div class="mb-3">
                  <label for="cantidad_total_cargue" class="form-control-label">Cantidad Total</label>
                  <input type="number" class="form-control" id="cantidad_total_cargue"
                    v-model="unloading.total_quantity" readonly>
                </div>
              </div>

            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalUnloading">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="saveUnloading">Guardar</button>
          </div>
        </div>
      </div>
    </div>




    <div class="modal fade" id="ModalFurnaceBurn" tabindex="-1" aria-labelledby="furnaceBurnModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title modal-title-underline" id="furnaceBurnModalLabel">Agregar registro de quema</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div class="row">
              <!-- Patio Carbón -->
              <div class="col-md-6 mb-3">
                <label for="patio_carbon" class="form-label">Patio Carbón</label>
                <select id="patio_carbon" class="form-select" v-model="furnaceBurn.patio_carbon">
                  <option value="">Seleccionar las opciones</option>
                  <option value="patio1">Patio 1</option>
                  <option value="patio2">Patio 2</option>
                  <option value="patio3">Patio 3</option>
                </select>
              </div>

              <!-- Cantidad de Carbón -->
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="carbon_quantity" class="form-label">Cantidad Toneladas de Carbón</label>
                  <div class="input-group furnace-input-group">
                    <input type="text" class="form-control" id="carbon_quantity" v-model="furnaceBurn.carbon_quantity">
                    <span class="input-group-text">TON</span>
                  </div>
                </div>
              </div>

              <div class="w-100"></div>

              <!-- Absorción de Agua -->
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="water_absorption" class="form-label">Absorción de Agua P1</label>
                  <div class="input-group furnace-input-group">
                    <input type="text" class="form-control" id="water_absorption" v-model="furnaceBurn.water_absorption">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="mb-3">
                  <label for="water_absorption" class="form-label">Absorción de Agua P2</label>
                  <div class="input-group furnace-input-group">
                    <input type="text" class="form-control" id="water_absorption" v-model="furnaceBurn.water_absorption_2">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>

              <!-- Sección Tiempo de Quema -->
              <div class="col-12 mb-4">
                <div class="card card-border-blue">
                  <div class="card-body">
                    <div class="d-flex align-items-center justify-content-between mb-3">
                      <span class="section-title">TIEMPO DE QUEMA</span>
                      <span class="badge bg-warning text-white fs-6">{{ burnTime }} HORAS</span>
                    </div>
                    <p class="text-muted small mb-3">Se calcula el tiempo y se ve reflejado aquí</p>

                    <div class="row">
                      <!-- Hora y Fecha de Inicio -->
                      <div class="col-md-3">
                        <label class="form-label bg-light px-2 py-1 rounded small">HORA INICIO</label>
                        <input type="time" class="form-control" v-model="furnaceBurn.start_time"
                          @change="calculateBurnTime">
                      </div>

                      <div class="col-md-3">
                        <label class="form-label bg-light px-2 py-1 rounded small">FECHA INICIO</label>
                        <input type="date" class="form-control" v-model="furnaceBurn.start_date"
                          @change="calculateBurnTime">
                      </div>

                      <!-- Hora y Fecha Final -->
                      <div class="col-md-3">
                        <label class="form-label bg-light px-2 py-1 rounded small">HORA FINAL</label>
                        <input type="time" class="form-control" v-model="furnaceBurn.end_time"
                          @change="calculateBurnTime">
                      </div>

                      <div class="col-md-3">
                        <label class="form-label bg-light px-2 py-1 rounded small">FECHA FINAL</label>
                        <input type="date" class="form-control" v-model="furnaceBurn.end_date"
                          @change="calculateBurnTime">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalFurnaceBurn">Cerrar</button>
            <button type="button" class="btn btn-warning" @click="saveFurnaceBurn">Guardar</button>
          </div>
        </div>
      </div>
    </div>




  </div>

</template>



<script>

import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import ArgonCheckbox from "../../../components/ArgonCheckbox.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import { Modal } from 'bootstrap';
//import * as bootstrap from 'bootstrap';
import { Collapse } from 'bootstrap';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "Models Create",
  setup() {
    const route = useRoute();
    return { route };
  },
  data() {
    return {
      furnaceBurn: {
        id: 0,
        production_oven_id: 0,
        patio_carbon: '',
        carbon_quantity: '',
        water_absorption: '',
        water_absorption_2: '',
        start_time: '',
        start_date: '',
        end_time: '',
        end_date: ''
      },
      furnaces: [],
      burnTime: 0,
      bsCollapse: [null, null, null, null],
      collapseOpen: [false, false, false, false],
      showMenu: false,
      ModalUsers: null,
      ModalDrying: null,
      ModalLoading: null,
      ModalUnloading: null,
      modalNovelty: null,
      modalDefects: null,
      modalModel: null,
      oficio_id: null,
      processes: [],
      cuadrillas: [],
      form: {
        id: 0,
        consecutive: '',
        consecutivo_secado: '',
        user_id: '',
        oven_id: 0,
        burn_number: 1,
        production_id: null,
        description: '',
        status: 0,
        started_at: '',
        estimated_at: '',
        finished_at: '',
        finished_user_id: '',
        production_models_id: 0,
        created_at: '',
        updated_at: '',
      },
      extrusion: {
        id: 0,
        production_id: 0,
        machine: '',
        setup_count: 0,
        nozzle_type: '',
        scheduled_time: 0,
        lost_time: 0,
        effective_time: 0,
        setup_number: 0,
        cut_count: 0,
        units_per_cut: 0,
        quantity: 0,
        extrusion_quantity: 0,
        extruded_weight: 0,
        dry_weight: 0,
        clay_consumption: 0,
        total_consumption: 0
      },
      drying: {
        id: 0,
        production_id: 0,
        oven_id: '',
        quantity: 0,
        damage_quantity: 0,
        averia_descargue: 0,
        averia_crudo: 0,
        warehouse_id: '',
        started_at: '',
        assigned_at: '',
        delivered_at: '',
        total_quantity: 0
      },
      loading: {
        id: 0,
        production_oven_id: 0,
        production_drying_id: 0,
        quantity: 0,
        burning_number: 0,
        averia_cargue: 0,
        averia_secado: 0,
        total_quantity: 0,
        warehouse_id: ''
      },
      unloading: {
        id: 0,
        production_oven_id:0,
        production_id: 0,
        inventory_id: 0,
        primera: 0,
        segunda: 0,
        tercera: 0,
        quantity: 0,
        averia_descargue: 0,
        averia_crudo: 0,
        total_quantity: 0,
        warehouse_id: '',
        details: [],
        warehouse_primera:'40',
        warehouse_segunda:'40',
        warehouse_tercera:'40',
      },
      dryings: [],
      loadings: [],
      unloadings: [],
      collapseInstances: {},
      size: {
        size: '',
        color_id: '',
        model_id: '',
        quantity: 0,
        status: 1
      },
      filteredUsers: [],
      userSearch: '',
      showUserSearch: false,
      bodegas: [],
      materials: [],
      models: [],
      insumos: [],
      insumosInventory: [],
      sizes: [],
      users: [],
      colors: [],
      purchases: [],
      selectedModel: {},
      purchase: {
        id: 0,
        inventory_id: 0,
        quantity: 0,
        price: 0,
        total_price: 0,
        supplier_name: ''
      },
      production_user: {
        id: 0,
        user_id: [],
        production_models_id: 0,
        oficio_id: 0,
        production_id: null,
        production_oven_id: null,
        modulo: 0,
        received_quantity: 0,
        delivered_quantity: 0,
        price: 0,
        assigned_at: '',
        estimated_at: '',
        cuadrilla: ''
      },
      production_model: {
        id: 0,
        production_id: 0,
        model_id: 0,
        size_id: 0,
        bodega_id: '',
        quantity_to_produce: 0,
        price: 0,
      },
      data: {},
      selectedOvenUserIds: [],
      modal: {
        id: 0,
        user_id: null,
        project_id: null,
        amount: "",
        status: "active"
      },
      novelty: {
        id: 0,
        production_id: 0,
        total: 0,
        observation: ''
      },
      fieldPayment: false,
      modalEvidencia: [],
      novelties: [],
      maxDryingQuantity: 0,
      syncingKardexLoading: false,
      syncingKardexUnloading: false,
      isSubmittingAssignUsers: false,
    };
  },
  components: { ArgonInput, ArgonButton, ArgonCheckbox },
  computed: {

    formattedTotalNovelty: {
      get() {
        // Formatea el precio a punto de mil y sin decimales
        return Math.floor(this.novelty.total).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        // Elimina los puntos y actualiza el precio sin decimales
        this.novelty.total = parseFloat(value.replace(/\./g, "") || 0);
      },
    },
    formattedTotalUser: {
      get() {
        // Formatea el precio a punto de mil y sin decimales
        return Math.floor(this.production_user.price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        // Elimina los puntos y actualiza el precio sin decimales
        this.production_user.price = parseFloat(value.replace(/\./g, "") || 0);
      },
    },
    totalPriceUser() {
      // Calcula el total y aplica el formateo
      const total = this.production_user.received_quantity * this.production_user.price;
      return total
        ? total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        : "0";
    },
    formattedPrice: {
      get() {
        return this.production_model.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        this.production_model.price = Math.floor(value.replace(/\./g, "") || 0);
      },
    },
    totalPrice() {
      // Calcula el total y aplica el formateo
      const total = this.production_model.quantity_to_produce * this.production_model.price;
      return total
        ? total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        : "0";
    },
    assignedUserRows() {
      return (this.data?.data || []).filter((v) => v.modulo === 3);
    },
    hasAssignedUsers() {
      return this.assignedUserRows.length > 0;
    },
    selectedAssignedUserRows() {
      const selectedSet = new Set((this.selectedOvenUserIds || []).map(Number));
      return this.assignedUserRows.filter((r) => selectedSet.has(Number(r.id)));
    },
    selectedBaseAction() {
      const first = this.selectedAssignedUserRows?.[0];
      if (!first) return null;
      return this.getAssignedUserNextAction(first);
    },
    // Usuarios asignados para DESCARGUE (módulo 4)
    descAssignedUserRows() {
      return (this.data?.data || []).filter((v) => v.modulo === 4);
    },
    hasDescAssignedUsers() {
      return this.descAssignedUserRows.length > 0;
    },
    selectedDescAssignedUserRows() {
      const selectedSet = new Set((this.selectedOvenUserIds || []).map(Number));
      return this.descAssignedUserRows.filter((r) => selectedSet.has(Number(r.id)));
    },
    selectedDescBaseAction() {
      const first = this.selectedDescAssignedUserRows?.[0];
      if (!first) return null;
      return this.getAssignedUserNextAction(first);
    },
    visibleUsers() {
      const query = this.normalizeText(this.userSearch);
      if (!query) return this.filteredUsers;

      return (this.filteredUsers || []).filter((user) => {
        const name = this.normalizeText(user?.name);
        return name.includes(query);
      });
    },
    loadingKardexNeedsSync() {
      const list = this.loadings || [];
      if (!list.length) return false;
      return list.some((l) => l.kardex_number == null || String(l.kardex_number).trim() === '');
    },
    loadingKardexLabel() {
      const list = this.loadings || [];
      const nums = [
        ...new Set(
          list
            .map((l) => l.kardex_number)
            .filter((k) => k != null && String(k).trim() !== ''),
        ),
      ];
      return nums.join(', ');
    },
    unloadingKardexNeedsSync() {
      const list = this.unloadings || [];
      if (!list.length) return false;
      return list.some((u) => u.kardex_number == null || String(u.kardex_number).trim() === '');
    },
    unloadingKardexLabel() {
      const list = this.unloadings || [];
      const nums = [
        ...new Set(
          list
            .map((u) => u.kardex_number)
            .filter((k) => k != null && String(k).trim() !== ''),
        ),
      ];
      return nums.join(', ');
    },

  },
  watch: {
    'form.status': function (newVal) {
      if (Number(newVal) === 1 || Number(newVal) === 2) this.$nextTick(() => this.initCollapseDescargue());
    },
    'extrusion.scheduled_time': function () {
      this.calcularTiempoEfectivo();
    },
    'extrusion.lost_time': function () {
      this.calcularTiempoEfectivo();
    },
    'extrusion.cut_count': function () {
      this.calcularCantidad();
    },
    'extrusion.units_per_cut': function () {
      this.calcularCantidad();
    },
    'extrusion.extruded_weight': function () {
      this.extrusion.dry_weight = this.extrusion.extruded_weight * 0.845;
    },
    'extrusion.extrusion_quantity': function () {
      this.drying.quantity = this.extrusion.extrusion_quantity;
      this.calcularConsumo();
    },
    'extrusion.dry_weight': function () {
      this.calcularConsumo();
    },
    // Calcular totales automáticamente para el módulo de secado
    'drying.quantity': function () {
      if (this.drying.quantity > this.maxDryingQuantity) {
        this.drying.quantity = this.maxDryingQuantity;
      }
      this.calcularTotalCantidadSecado();
    },
    'drying.damage_quantity': function () {
      this.calcularTotalCantidadSecado();
    },
    'drying.averia_descargue': function () {
      this.calcularTotalCantidadSecado();
    },
    'drying.averia_crudo': function () {
      this.calcularTotalCantidadSecado();
    },

    // Calcular totales: cantidad total = cantidad - averia_cargue - averia_secado (averías se restan)
    'loading.quantity': function () {
      const q = Number(this.loading.quantity ?? 0);
      const ac = Number(this.loading.averia_cargue ?? 0);
      const as_ = Number(this.loading.averia_secado ?? 0);
      const maxAvailable = this.selectedModel?.total_available ?? 0;
      const totalQuantity = q - ac - as_;
      if (totalQuantity > maxAvailable) {
        this.loading.quantity = maxAvailable + ac + as_;
      }
      this.calcularTotalCantidadCargue();
    },
    'loading.averia_cargue': function () {
      const q = Number(this.loading.quantity ?? 0);
      const ac = Number(this.loading.averia_cargue ?? 0);
      const as_ = Number(this.loading.averia_secado ?? 0);
      const totalQuantity = q - ac - as_;
      if (totalQuantity < 0) {
        this.loading.averia_cargue = Math.max(0, q - as_);
      } else if (totalQuantity > this.selectedModel?.total_available) {
        this.loading.averia_cargue = Math.max(0, q - (this.selectedModel?.total_available ?? 0) - as_);
      }
      this.calcularTotalCantidadCargue();
    },
    'loading.averia_secado': function () {
      const q = Number(this.loading.quantity ?? 0);
      const ac = Number(this.loading.averia_cargue ?? 0);
      const as_ = Number(this.loading.averia_secado ?? 0);
      const totalQuantity = q - ac - as_;
      if (totalQuantity < 0) {
        this.loading.averia_secado = Math.max(0, q - ac);
      } else if (totalQuantity > this.selectedModel?.total_available) {
        this.loading.averia_secado = Math.max(0, q - (this.selectedModel?.total_available ?? 0) - ac);
      }
      this.calcularTotalCantidadCargue();
    },
    'unloading.primera': function () {
      const quantity = Number(this.unloading.primera ?? 0) + Number(this.unloading.segunda ?? 0) + Number(this.unloading.tercera ?? 0) + Number(this.unloading.averia_descargue ?? 0) + Number(this.unloading.averia_crudo ?? 0);

      const rest = this.selectedModel.total_quantity-(quantity - this.unloading.primera);
      // Verificar si la cantidad acumulada excede el total permitido
      if (quantity > this.selectedModel.total_quantity) {
        // Ajustar unloading.primera para que no exceda el total
        this.unloading.primera = rest < 0 ? 0 : rest; // remplazar la cantidad por el valor restante
      }
      this.calcularTotalCantidadDescargue();
    },
    'unloading.segunda': function () {
      const quantity = Number(this.unloading.primera ?? 0) + Number(this.unloading.segunda ?? 0) + Number(this.unloading.tercera ?? 0) + Number(this.unloading.averia_descargue ?? 0) + Number(this.unloading.averia_crudo ?? 0);

      const rest = this.selectedModel.total_quantity-(quantity - this.unloading.segunda);
      // Verificar si la cantidad acumulada excede el total permitido
      if (quantity > this.selectedModel.total_quantity) {
        // Ajustar unloading.primera para que no exceda el total
        this.unloading.segunda = rest < 0 ? 0 : rest; // remplazar la cantidad por el valor restante
      }
      this.calcularTotalCantidadDescargue();
    },
    'unloading.tercera': function () {
       const quantity = Number(this.unloading.primera ?? 0) + Number(this.unloading.segunda ?? 0) + Number(this.unloading.tercera ?? 0) + Number(this.unloading.averia_descargue ?? 0) + Number(this.unloading.averia_crudo ?? 0);

      const rest = this.selectedModel.total_quantity-(quantity - this.unloading.tercera);
      // Verificar si la cantidad acumulada excede el total permitido
      if (quantity > this.selectedModel.total_quantity) {
        // Ajustar unloading.primera para que no exceda el total
        this.unloading.tercera = rest < 0 ? 0 : rest; // remplazar la cantidad por el valor restante
      }
      this.calcularTotalCantidadDescargue();
    },
    'unloading.averia_descargue': function () {
      const quantity = Number(this.unloading.primera ?? 0) + Number(this.unloading.segunda ?? 0) + Number(this.unloading.tercera ?? 0) + Number(this.unloading.averia_descargue ?? 0) + Number(this.unloading.averia_crudo ?? 0);

      const rest = this.selectedModel.total_quantity-(quantity - this.unloading.averia_descargue);
      // Verificar si la cantidad acumulada excede el total permitido
      if (quantity > this.selectedModel.total_quantity) {
        // Ajustar unloading.primera para que no exceda el total
        this.unloading.averia_descargue = rest < 0 ? 0 : rest; // remplazar la cantidad por el valor restante
      }
      this.calcularTotalCantidadDescargue();
    },
    'unloading.averia_crudo': function () {
      const quantity = Number(this.unloading.primera ?? 0) + Number(this.unloading.segunda ?? 0) + Number(this.unloading.tercera ?? 0) + Number(this.unloading.averia_descargue ?? 0) + Number(this.unloading.averia_crudo ?? 0);

      const rest = this.selectedModel.total_quantity-(quantity - this.unloading.averia_crudo);
      // Verificar si la cantidad acumulada excede el total permitido
      if (quantity > this.selectedModel.total_quantity) {
        // Ajustar unloading.primera para que no exceda el total
        this.unloading.averia_crudo = rest < 0 ? 0 : rest; // remplazar la cantidad por el valor restante
      }
      this.calcularTotalCantidadDescargue();
    },


    'form.bodega_id': function () {
      this.handleBodegaChange();
    },

  },
  methods: {
    toggleUserSearch() {
      this.showUserSearch = !this.showUserSearch;
      if (!this.showUserSearch) {
        this.userSearch = '';
      }
    },
    normalizeText(value) {
      return (value ?? '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();
    },
    async getBodegas() {
      try {
        // Obtener las bodegas desde el store (pueden venir paginadas como response.data.data)
        const data = await this.$store.dispatch('bodegas/getAll');
        this.bodegas = Array.isArray(data) ? data : (data?.data && Array.isArray(data.data) ? data.data : []);

        // Obtener referencia al select
        const $selectModulo = $(this.$refs.moduloPrimera);

        // Destruir la instancia previa de Select2 si existe
        if ($selectModulo.data('select2')) {
          $selectModulo.select2('destroy');
        }

        // Limpiar y agregar las opciones dinámicamente
        $selectModulo.empty().append('<option value="">Seleccionar módulo</option>');

        this.bodegas.filter(h => parseInt(h.tipo) === 5).forEach(model => {
          const option = new Option(model.name, model.id);
          $(option).attr('data-artificial', model.artificial ? '1' : '0');
          $selectModulo.append(option);
        });

        // Inicializar Select2
        $selectModulo.select2({
          placeholder: 'Seleccione un módulo',
          allowClear: true, // Cambiado a true para permitir limpiar la selección
          dropdownParent: $('#ModalUnloading .modal-body')
        }).on('change', () => {
           this.unloading.warehouse_primera = $selectModulo.val();
        });

        // Si hay un valor pre-seleccionado en drying.warehouse_id
        if (this.unloading.warehouse_primera) {
          $selectModulo.val(this.unloading.warehouse_primera).trigger('change');
        }

        $selectModulo.val("40").trigger('change');
        this.unloading.warehouse_primera = "40";


        // Obtener referencia al select
        const $selectModuloSegunda = $(this.$refs.moduloSegunda);

        // Destruir la instancia previa de Select2 si existe
        if ($selectModuloSegunda.data('select2')) {
          $selectModuloSegunda.select2('destroy');
        }

        // Limpiar y agregar las opciones dinámicamente
        $selectModuloSegunda.empty().append('<option value="">Seleccionar módulo</option>');

        this.bodegas.filter(h => parseInt(h.tipo) === 5).forEach(model => {
          const option = new Option(model.name, model.id);
          $(option).attr('data-artificial', model.artificial ? '1' : '0');
          $selectModuloSegunda.append(option);
        });

        // Inicializar Select2
        $selectModuloSegunda.select2({
          placeholder: 'Seleccione un módulo',
          allowClear: true, // Cambiado a true para permitir limpiar la selección
          dropdownParent: $('#ModalUnloading .modal-body')
        }).on('change', () => {
           this.unloading.warehouse_segunda = $selectModuloSegunda.val();
        });

        // Si hay un valor pre-seleccionado en drying.warehouse_id
        if (this.unloading.warehouse_segunda) {
          $selectModuloSegunda.val(this.unloading.warehouse_segunda).trigger('change');
        }
        $selectModuloSegunda.val("40").trigger('change');
        this.unloading.warehouse_segunda = "40";

        // Obtener referencia al select
        const $selectModuloTercera = $(this.$refs.moduloTercera);

        // Destruir la instancia previa de Select2 si existe
        if ($selectModuloTercera.data('select2')) {
          $selectModuloTercera.select2('destroy');
        }

        // Limpiar y agregar las opciones dinámicamente
        $selectModuloTercera.empty().append('<option value="">Seleccionar módulo</option>');

        this.bodegas.filter(h => parseInt(h.tipo) === 5).forEach(model => {
          const option = new Option(model.name, model.id);
          $(option).attr('data-artificial', model.artificial ? '1' : '0');
          $selectModuloTercera.append(option);
        });

        // Inicializar Select2
        $selectModuloTercera.select2({
          placeholder: 'Seleccione un módulo',
          allowClear: true, // Cambiado a true para permitir limpiar la selección
          dropdownParent: $('#ModalUnloading .modal-body')
        }).on('change', () => {
           this.unloading.warehouse_tercera = $selectModuloTercera.val();
        });

        // Si hay un valor pre-seleccionado en drying.warehouse_id
        if (this.unloading.warehouse_tercera) {
          $selectModuloTercera.val(this.unloading.warehouse_tercera).trigger('change');
        }
        $selectModuloTercera.val("40").trigger('change');
        
        this.unloading.warehouse_tercera = "40";

        


      } catch (error) {
        console.error('Error al obtener bodegas:', error);
      }
    },
    calculateBurnTime() {
      // Calcular tiempo de quema si todas las fechas y horas están completas
      if (this.furnaceBurn.start_date && this.furnaceBurn.start_time &&
        this.furnaceBurn.end_date && this.furnaceBurn.end_time) {

        const startDateTime = new Date(`${this.furnaceBurn.start_date}T${this.furnaceBurn.start_time}`);
        const endDateTime = new Date(`${this.furnaceBurn.end_date}T${this.furnaceBurn.end_time}`);

        const diffInMs = endDateTime - startDateTime;
        const diffInHours = Math.round(diffInMs / (1000 * 60 * 60));

        if (diffInHours > 0) {
          this.burnTime = diffInHours;
        }
      }
    },

    getFurnaceBurnHours(furnace) {
      if (!furnace.start_date || !furnace.start_time || !furnace.end_date || !furnace.end_time) {
        return 0;
      }
      try {
        const startDateTime = new Date(`${furnace.start_date}T${furnace.start_time}`);
        const endDateTime = new Date(`${furnace.end_date}T${furnace.end_time}`);
        const diffInMs = endDateTime - startDateTime;
        const diffInHours = Math.round(diffInMs / (1000 * 60 * 60));
        return diffInHours > 0 ? diffInHours : 0;
      } catch (e) {
        return 0;
      }
    },
    async getFurnace() {
      this.furnaces = await this.$store.dispatch("productionOvenFurnace/getData", this.form.id);
    },
    async saveFurnaceBurn() {
      // Validaciones básicas
      if (!this.furnaceBurn.patio_carbon) {
        alert('Por favor seleccione un patio de carbón');
        return;
      }

      if (!this.furnaceBurn.carbon_quantity) {
        alert('Por favor ingrese la cantidad de carbón');
        return;
      }

      if (!this.furnaceBurn.water_absorption) {
        alert('Por favor ingrese la absorción de agua');
        return;
      }



      // Aquí iría la lógica para guardar los datos
      console.log('Datos de quema a guardar:', {
        ...this.furnaceBurn,
        burn_time: this.burnTime
      });

      console.log("Guardar Extrusion");
      try {
        const response = await this.$store.dispatch("productionOvenFurnace/save", this.furnaceBurn);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then(() => {
            this.getFurnace();
            this.closeModalFurnaceBurn();
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        Swal.close();
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }


    },

    openModalFurnace() {
      const modalElement = document.getElementById('ModalFurnaceBurn');
      this.modalFurnace = new Modal(modalElement); // Guarda la instancia del modal
      this.modalFurnace.show(); // Muestra el modal
    },
    closeModalFurnaceBurn() {
      // Cerrar modal usando Bootstrap
      if (this.modalFurnace) {
        this.modalFurnace.hide(); // Cierra el modal
      }
      const oven_id = this.furnaceBurn.production_oven_id;

      // Resetear formulario
      this.furnaceBurn = {
        id: 0,
        production_oven_id:oven_id,
        patio_carbon: '',
        carbon_quantity: '',
        water_absorption: '',
        start_time: '',
        start_date: '',
        end_time: '',
        end_date: ''
      };
      this.burnTime = 20;
    },

    async deleteLoadings(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionLoading/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            this.getLoadings();
            this.getDrying();

            await Swal.fire(
              'Eliminado!',
              'El registro se ha sido eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el empleado');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },

    async deleteFurnace(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionOvenFurnace/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            this.getFurnace();

            await Swal.fire(
              'Eliminado!',
              'El registro se ha sido eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el empleado');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async deleteUnloadings(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionUnloading/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            this.getMaterials();
            this.getLoadings();
            this.getUnloadings();

            await Swal.fire(
              'Eliminado!',
              'El registro se ha sido eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el empleado');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },

    async checkDeliveredDrying(value) {

      try {
        const result = await Swal.fire({
          title: 'Marcar como entregado',
          text: 'Al realizar esta acción se registrará la fecha de entrega del descargue.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, aceptar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {

          const now = new Date();
          const pad = n => String(n).padStart(2, '0');

          value.delivered_at = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;

          const response = await this.$store.dispatch("productionUnloading/save", value);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Registro de descargue entregado!',
              'El registro se ha guardado correctamente.',
              'success'
            );

            this.getUnloadings();
          } else {
            throw new Error(response.data.message || 'Error al guardar el registro');
          }
        }
      } catch (error) {
        console.error("Error al guardar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    calculateTotalQuantity() {
      const total = this.dryings.reduce((total, item) => {
        return total + (Number(item.quantity) || 0);
      }, 0);

      this.drying.quantity = total - this.extrusion.extrusion_quantity;
      this.maxDryingQuantity = this.drying.quantity;
    },
    initCollapseDescargue() {
      const ref = this.$refs.collapse3;
      if (ref && !this.bsCollapse[3]) {
        this.bsCollapse[3] = new Collapse(ref, { toggle: false });
        ref.addEventListener('shown.bs.collapse', () => { this.collapseOpen[3] = true });
        ref.addEventListener('hidden.bs.collapse', () => { this.collapseOpen[3] = false });
      }
    },
    toggleCollapse(index) {
      if (index === 3 && !this.bsCollapse[3] && this.$refs.collapse3) this.initCollapseDescargue();
      // En Horno: si una tarjeta se despliega, las demás se cierran (acordeón: CARGUE HORNO y DESCARGUE)
      const hornoIndices = [2, 3];
      if (hornoIndices.includes(index)) {
        hornoIndices.forEach(i => {
          if (i !== index && this.bsCollapse[i] && this.collapseOpen[i]) {
            this.bsCollapse[i].hide();
          }
        });
      }
      const selected = this.bsCollapse[index];
      if (selected) selected.toggle();
    },
    calcularTotalCantidadSecado() {
      this.drying.total_quantity =
        Number(this.drying.quantity) -
        Number(this.drying.damage_quantity) -
        Number(this.drying.averia_descargue) -
        Number(this.drying.averia_crudo);
    },
    calcularTotalCantidadCargue() {
      this.loading.total_quantity = Number(this.loading.quantity ?? 0) + Number(this.loading.averia_cargue ?? 0) + Number(this.loading.averia_secado ?? 0);
    },

    calcularTotalCantidadDescargue() {
      this.unloading.total_quantity = Number(this.unloading.primera ?? 0) + Number(this.unloading.segunda ?? 0) + Number(this.unloading.tercera ?? 0) + Number(this.unloading.averia_descargue ?? 0) + Number(this.unloading.averia_crudo ?? 0);
    },
    async saveExtruction() {
      console.log("Guardar Extrusion");
      try {
        const response = await this.$store.dispatch("productionExtrusion/save", this.extrusion);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then(() => {
            this.extrusion.id = response?.data?.id || 0;
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        Swal.close();
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },


    async getDrying() {
      const dryingList = await this.$store.dispatch("productionDrying/getAll");

      // Filtrar solo los secados entregados y con disponibilidad
      this.dryings = dryingList.filter(h => h.delivered_at != null && h.total_available > 0);

      // Referencia al select
      const $selectModulo = $(this.$refs.moduloSelect);

      // Destruir select2 anterior si existe para evitar duplicados de eventos
      if ($selectModulo.hasClass("select2-hidden-accessible")) {
        $selectModulo.select2("destroy");
      }

      // Limpiar y agregar opción por defecto
      $selectModulo.empty().append('<option value="">Seleccionar modulo</option>');

      // Agregar opciones de los secados
      this.dryings.forEach(model => {
        $selectModulo.append(new Option(model?.production?.model?.name + ` - Módulo: ${model?.bodega?.name}` + ` - Cantidad: ${model?.total_available}`, model.id));
      });


      // Inicializar select2
      $selectModulo.select2({
        placeholder: 'Seleccione un modulo',
        allowClear: false,
        dropdownParent: $('#ModalLoading .modal-body')
      }).on('change', () => {

        const selectedId = $selectModulo.val();

        this.loading.production_drying_id = Number($selectModulo.val());

        const selectedModel = this.dryings.find(model => model.id == selectedId);

        if (selectedModel) {
          this.selectedModel = selectedModel;
          console.log('Modelo seleccionado:', selectedModel);
        } else {
          console.log('No se encontró el modelo seleccionado.');
        }
 
      });
    },

    async getLoadings() {

      this.loadings = await this.$store.dispatch("productionLoading/getData", this.form.id);

      const loadingsData = await this.$store.dispatch("productionLoading/getDataOven", this.form.id);

      const $selectUnloadingWarehouse = $(this.$refs.selectUnloadingWarehouse);
      $selectUnloadingWarehouse.empty().append('<option value="">Seleccionar modulo</option>');
      loadingsData.forEach(model => {
        $selectUnloadingWarehouse.append(new Option(model?.model_name + " - Cantidad: " + model?.total_quantity, model.model_id));
      });

      $(this.$refs.selectUnloadingWarehouse).select2({
        placeholder: 'Seleccione un módulo',
        allowClear: false,
        dropdownParent: $('#ModalUnloading .modal-body')
      }).on('change', () => {
        const selectedId = $(this.$refs.selectUnloadingWarehouse).val();

        // buscar modelo por id
        const selectedModel = this.materials.find(model => model.id == selectedId);

        // buscar datos adicionales (puede no existir)
        const selectedData = loadingsData.find(model => model.model_id == selectedId);

        if (selectedModel) {
          // asignar id al objeto unloading
          this.unloading.inventory_id = selectedId;

          // prevenir error si selectedData no existe
          selectedModel.total_quantity = selectedData?.total_quantity ?? 0;

          // actualizar el modelo seleccionado en el componente
          this.selectedModel = selectedModel;

          console.log('Modelo seleccionado:', selectedModel);
        } else {
          console.warn('No se encontró el modelo seleccionado.');
        }
      });


    },
    async getUnloadings() {
      this.unloadings = await this.$store.dispatch("productionUnloading/getData", this.form.id);
    },
    async syncKardexLoading() {
      if (!this.form?.id) return;
      this.syncingKardexLoading = true;
      try {
        await this.$store.dispatch("productionLoading/syncKardex", this.form.id);
        await this.getLoadings();
      } catch (error) {
        console.error("syncKardexLoading:", error);
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: error?.data?.message || error?.message || "No se pudo sincronizar el kardex de cargue.",
        });
      } finally {
        this.syncingKardexLoading = false;
      }
    },
    async syncKardexUnloading() {
      if (!this.form?.id) return;
      this.syncingKardexUnloading = true;
      try {
        await this.$store.dispatch("productionUnloading/syncKardex", this.form.id);
        await this.getUnloadings();
      } catch (error) {
        console.error("syncKardexUnloading:", error);
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: error?.data?.message || error?.message || "No se pudo sincronizar el kardex de descargue.",
        });
      } finally {
        this.syncingKardexUnloading = false;
      }
    },
    async saveDrying() {
      console.log("Guardar secado");

      if (this.drying.quantity <= 0) {
        await Swal.fire({
          icon: 'error',
          title: 'Error en la cantidad',
          text: 'La cantidad no puede ser cero o negativa',
          confirmButtonText: 'Entendido',
          confirmButtonColor: '#3085d6',
        });
        return; // Detiene la ejecución si la validación falla
      }

      try {
        const response = await this.$store.dispatch("productionDrying/save", this.drying);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then(() => {
            this.drying.id = response?.data?.id || 0;
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        Swal.close();
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async confirmLoading(loading) {
      if (!loading?.id || loading?.confirmed) return;
      const result = await Swal.fire({
        title: '¿Confirmar información?',
        text: 'Una vez confirmado no podrá editar las averías de este registro.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#1f2d5a',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sí, confirmar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;

      try {
        const payload = { ...loading, confirmed: true };
        const response = await this.$store.dispatch("productionLoading/save", payload);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({ icon: 'success', title: 'Confirmado', text: 'El registro ha sido confirmado.', timer: 2000, showConfirmButton: false });
          this.getLoadings();
        } else {
          throw new Error(response?.data?.message || 'Error al confirmar');
        }
      } catch (error) {
        console.error("Error al confirmar:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'No se pudo confirmar el registro.',
        });
        this.getLoadings();
      }
    },
    async updateLoadingAverias(loading) {
      if (!loading?.id || loading?.confirmed) return;
      try {
        loading.total_quantity = Math.max(0, Number(loading.quantity ?? 0) - Number(loading.averia_cargue ?? 0) - Number(loading.averia_secado ?? 0));
        const response = await this.$store.dispatch("productionLoading/save", loading);
        if (response && response.status >= 200 && response.status < 300) {
          this.getLoadings();
        } else {
          throw new Error(response?.data?.message || 'Error al actualizar');
        }
      } catch (error) {
        console.error("Error al actualizar averías:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'No se pudo actualizar el registro.',
        });
        this.getLoadings();
      }
    },
    async saveLoading() {
      console.log("Guardar cargue");
      try {
        const response = await this.$store.dispatch("productionLoading/save", this.loading);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then(() => {

            this.selectedModel = {};

            this.getDrying();

            this.getLoadings();

            this.closeModalLoading();


          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        Swal.close();
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async saveUnloading() {
      console.log("Guardar descargue",this.unloading);
      if (!this.unloading.inventory_id || Number(this.unloading.inventory_id) === 0) {
        await Swal.fire({
          icon: 'warning',
          title: 'Material requerido',
          text: 'Debe seleccionar un material de cargue en el desplegable antes de guardar.',
          confirmButtonText: 'Entendido',
        });
        return;
      }
      try {
        const response = await this.$store.dispatch("productionUnloading/save", this.unloading);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then(() => {
            this.selectedModel = {};
            this.getUnloadings();
            this.getLoadings();
            this.closeModalUnloading();

             this.getMaterials();

             this.getModels();
             this.getBodegas();
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        Swal.close();
        console.error("Error al crear el registro:", error);
        const msg = error.response?.data?.message || error.message || 'Error al guardar el registro';
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: msg,
        });
      }
    },
    initCollapses() {
      // Inicializar cada collapse individualmente
      const collapseElements = document.querySelectorAll('.collapse');
      collapseElements.forEach(el => {
        this.collapseInstances[el.id] = new Modal(el, {
          toggle: false
        });
      });
    },
    calcularTiempoEfectivo() {
      this.extrusion.effective_time = Math.max(0, this.extrusion.scheduled_time - this.extrusion.lost_time);
    },
    calcularCantidad() {
      this.extrusion.quantity = this.extrusion.cut_count * this.extrusion.units_per_cut;
    },
    calcularConsumo() {
      this.extrusion.clay_consumption = (this.extrusion.extrusion_quantity * this.extrusion.dry_weight) / 1000;
      this.extrusion.total_consumption = this.extrusion.setup_count > 0
        ? (this.extrusion.clay_consumption * 1000) / this.extrusion.setup_count
        : 0;
    },
    editModal(detail) {
      this.purchase = {
        id: detail.id,
        inventory_id: detail.inventory_id,
        quantity: detail.quantity,
      };

      $('#insumosEdit').val(detail.inventory_id).trigger('change');
      const modalElement = document.getElementById('ModalEditInsumo');
      this.modalEdit = new Modal(modalElement); // Guarda la instancia del modal
      this.modalEdit.show(); // Muestra el modal
    },
    closeEditModal() {
      if (this.modalEdit) {
        this.modalEdit.hide(); // Cierra el modal
      }
    },
    async submitEditForm() {
      try {
        const response = await this.$store.dispatch("productionDetails/save", this.purchase);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then(() => {
            this.getInsumos();
            this.closeEditModal();
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        Swal.close();
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async onBodegaChange(data) {

      await this.$store.dispatch('productionModels/save', data);

      await Swal.fire({
        icon: 'success',
        title: '¡Éxito!',
        text: 'Bodega asignada',
        confirmButtonText: 'Aceptar',
        backdrop: true,
      });

    },
    async handleStatusChange() {
      const newStatus = Number(this.form.status);
      //const prevStatus = newStatus === 1 ? 0 : 1;

      // Cambiar a Activo: Cargue confirmado + al menos un usuario asignado y todos con check de validación
      if (newStatus === 1) {
        const sinConfirmar = (this.loadings || []).filter(l => !l.confirmed);
        if (sinConfirmar.length > 0) {
          this.form.status = 0;
          const listado = sinConfirmar.map(l => l?.driying?.production?.model?.name || 'Registro').join(', ');
          await Swal.fire({
            icon: 'warning',
            title: 'No se puede cambiar a Activo',
            html: `<p>Para pasar a estado Activo debe completar todos los datos y requisitos en <strong>Cargue de horno</strong>.</p><p class="mb-0 mt-2"><strong>Falta por completar:</strong></p><ul class="text-start mt-1 mb-0"><li>Confirmar todos los registros de Cargue (faltan ${sinConfirmar.length}): ${listado || '—'}</li></ul>`,
            confirmButtonText: 'Entendido',
          });
          return;
        }
        const usuariosAsignados = (this.data?.data || []);
        if (usuariosAsignados.length === 0) {
          this.form.status = 0;
          await Swal.fire({
            icon: 'warning',
            title: 'No se puede cambiar a Activo',
            html: '<p>Para pasar a estado Activo debe completar todos los datos y requisitos en <strong>Cargue de horno</strong>.</p><p class="mb-0 mt-2"><strong>Falta por completar:</strong></p><ul class="text-start mt-1 mb-0"><li>Asignar al menos un usuario (actualmente no hay ninguno asignado)</li></ul>',
            confirmButtonText: 'Entendido',
          });
          return;
        }
        const sinValidar = usuariosAsignados.filter(u => !u.validated_date);
        if (sinValidar.length > 0) {
          this.form.status = 0;
          const listado = sinValidar.map(u => u?.user?.name || 'Registro').join(', ');
          await Swal.fire({
            icon: 'warning',
            title: 'No se puede cambiar a Activo',
            html: `<p>Para pasar a estado Activo debe completar todos los datos y requisitos en <strong>Cargue de horno</strong>.</p><p class="mb-0 mt-2"><strong>Falta por completar:</strong></p><ul class="text-start mt-1 mb-0"><li>Marcar el check de validación de todos los usuarios asignados (faltan ${sinValidar.length}): ${listado || '—'}</li></ul>`,
            confirmButtonText: 'Entendido',
          });
          return;
        }
        const result = await Swal.fire({
          title: 'Confirmar cambio de estado',
          text: 'Al cambiar a estado activo',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, confirmar',
          cancelButtonText: 'Cancelar',
        });
        if (result.isConfirmed) {
          this.handleStatusChangeSave();
        } else {
          this.form.status = 0;
        }
        return;
      }

      // Cambiar a Terminado: debe haber al menos un Descargue y todos con entrega completada (check y campos)
      if (newStatus === 2) {
        const list = this.unloadings || [];
        if (list.length === 0) {
          this.form.status = 1;
          await Swal.fire({
            icon: 'warning',
            title: 'No se puede cambiar a Terminado',
            html: '<p>Debe agregar al menos un registro en <strong>Descargue</strong> y completar la entrega (marcar con check) de todos antes de pasar a estado Terminado.</p>',
            confirmButtonText: 'Entendido',
          });
          return;
        }
        const sinEntregar = list.filter(u => !u.delivered_at);
        if (sinEntregar.length > 0) {
          this.form.status = 1;
          const listado = sinEntregar.map(u => u?.inventory?.name || 'Registro').join(', ');
          await Swal.fire({
            icon: 'warning',
            title: 'No se puede cambiar a Terminado',
            html: `<p>Debe completar la entrega (marcar con check) y los campos de todos los registros de <strong>Descargue</strong> antes de pasar a estado Terminado.</p>
              <p class="mb-0 mt-2"><strong>Faltan por entregar ${sinEntregar.length} registro(s):</strong></p>
              <p class="text-start text-muted small mt-1">${listado || '—'}</p>`,
            confirmButtonText: 'Entendido',
          });
          return;
        }
        const usuariosAsignados = (this.data?.data || []);
        const conCheckUsuario = usuariosAsignados.filter(u => u.validated_date);
        if (usuariosAsignados.length === 0) {
          this.form.status = 1;
          await Swal.fire({
            icon: 'warning',
            title: 'No se puede cambiar a Terminado',
            html: '<p>Debe tener al menos un usuario asignado en <strong>USUARIOS ASIGNADOS</strong> y que tenga el check de validación completado antes de pasar a estado Terminado.</p>',
            confirmButtonText: 'Entendido',
          });
          return;
        }
        if (conCheckUsuario.length === 0) {
          this.form.status = 1;
          await Swal.fire({
            icon: 'warning',
            title: 'No se puede cambiar a Terminado',
            html: '<p>Debe completar al menos un check de validación en <strong>USUARIOS ASIGNADOS</strong> (marcar como validado al menos un usuario) antes de pasar a estado Terminado.</p>',
            confirmButtonText: 'Entendido',
          });
          return;
        }
      }

      this.handleStatusChangeSave();
    },
    async handleStatusChangeSave() {
      // Al terminar el horno, guardar fecha finalización para que aparezca en informes.
      if (Number(this.form.status) === 2 && !this.form.finished_at) {
        this.form.finished_at = this.nowAsDbDateTime();
      }
      const payload = { ...this.form };
      if (!payload.production_models_id) {
        delete payload.production_models_id;
      }
      // Asegurar que user_id sea un entero válido
      if (!payload.user_id) {
        const storedUser = JSON.parse(localStorage.getItem('user') || 'null');
        if (storedUser && storedUser.id) {
          payload.user_id = Number(storedUser.id);
        }
      } else {
        payload.user_id = Number(payload.user_id);
      }
      const response = await this.$store.dispatch("productionOven/save", payload);
      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire({
          icon: 'success',
          title: '¡Éxito!',
          text: 'El estado cambio correctamente',
          confirmButtonText: 'Aceptar',
          backdrop: true,
        });
      } else {
        await Swal.fire({
          icon: 'error',
          title: '¡Ocurrio un error!',
          text: response.data.message || 'Error al guardar el registro',
          confirmButtonText: 'Aceptar',
          backdrop: true,
        });
      }
    },
    async handleBodegaChange() {
      await this.$store.dispatch("production/save", this.form);
    },
    
    async getNovelties() {
      this.novelties = await this.$store.dispatch('productionNovelty/getData', this.form.id);
    },
    /** Cantidad por defecto para asignar al usuario según módulo (3: cargue, 4: descargue) */
    getDefaultReceivedQuantityForModule(modulo) {
      const mod = Number(modulo);
      if (mod === 3) {
        // CARGUE: usar cantidad total cargada al horno
        const load = this.loading || {};
        const qty = Number(load.total_quantity || load.quantity || 0);
        return isNaN(qty) ? 0 : qty;
      }
      if (mod === 4) {
        // DESCARGUE: usar cantidad total descargada
        const unl = this.unloading || {};
        const qty = Number(unl.total_quantity || unl.quantity || 0);
        return isNaN(qty) ? 0 : qty;
      }
      return 0;
    },
    async getOficios() {
      try {
        // Obtener los oficios desde el store
        this.processes = await this.$store.dispatch('users/getOficios');

        // Obtener referencia al select
        const $selectOficio = $(this.$refs.processesSelect);

        // Destruir la instancia previa de Select2 si existe
        if ($selectOficio.data('select2')) {
          $selectOficio.select2('destroy');
        }

        // Limpiar y agregar las opciones dinámicamente
        $selectOficio.empty().append('<option value="">Seleccione un oficio</option>');

        this.processes.forEach(oficio => {

          if(this.production_user.modulo==3){
            if(oficio.id==43 || oficio.id==42 || oficio.id==44 || oficio.id==39){
              $selectOficio.append(new Option(oficio.name, oficio.id));
            }
          }
          
          if(this.production_user.modulo==4){
            if(oficio.id==42 || oficio.id==44 || oficio.id==39 ){
              $selectOficio.append(new Option(oficio.name, oficio.id));
            }
          }
          
        });

        // Inicializar Select2
        $selectOficio.select2({
          placeholder: 'Seleccione un oficio',
          allowClear: true,
        }).on('change', () => {
          this.production_user.oficio_id = $selectOficio.val(); // Usar la variable ya definida
          this.userSearch = '';
          this.showUserSearch = false;
          this.filterUsersByOficioAndCuadrilla();
        });

        // Si hay un valor pre-seleccionado en production_user.oficio_id
        if (this.production_user.oficio_id) {
          $selectOficio.val(this.production_user.oficio_id).trigger('change');
        }

      } catch (error) {
        console.error('Error al obtener oficios:', error);
      }
    },
    async getCuadrillas() {
      this.cuadrillas = await this.$store.dispatch('crews/getAll');
    },
    async getMaterials() {
      this.materials = await this.$store.dispatch('inventory/getAll');
    },
    async getUsers() {
      this.users = await this.$store.dispatch('users/getAll', 'all');
      this.filterUsersByOficioAndCuadrilla();
    },
    filterUsersByOficioAndCuadrilla() {
      const oficioId = this.production_user.oficio_id;
      const cuadrillaId = this.production_user.cuadrilla;

      if (!oficioId) {
        this.filteredUsers = [];
        return;
      }

      const oficioIdNum = Number(oficioId);
      const cuadrillaIdNum = cuadrillaId ? Number(cuadrillaId) : null;
      const oficioName = (this.processes || [])
        .find((o) => Number(o.id) === oficioIdNum)?.name
        ?.toString()
        .trim()
        .toLowerCase();

      const roleMap = {
        'administrador': '1',
        'supervisor': '2',
        'operario': '3',
      };
      const roleToMatch = oficioName ? roleMap[oficioName] : undefined;

      // Primer filtro: solo por oficio (todos los usuarios de ese oficio)
      let usersByOficio = this.users.filter((user) => {
        if (roleToMatch) {
          const userRole = user?.role?.toString?.() ?? '';
          return userRole === roleToMatch;
        }
        const processes = Array.isArray(user.processes) ? user.processes : JSON.parse(user.processes || "[]");
        return processes.map(Number).includes(oficioIdNum);
      });

      // Segundo filtro: por cuadrilla (opcional)
      if (cuadrillaIdNum != null && cuadrillaId !== '') {
        usersByOficio = usersByOficio.filter((user) => {
          const userCuadrilla = user?.cuadrilla === '' || user?.cuadrilla === null || user?.cuadrilla === undefined
            ? null
            : Number(user.cuadrilla);
          return userCuadrilla === cuadrillaIdNum;
        });
      }

      this.filteredUsers = usersByOficio;
    },
    isValidDate(date) {
      if (!date) {
        return false;
      }
      const parsedDate = new Date(date);
      return !isNaN(parsedDate.getTime());
    },
    async getModels() {
      this.models = await this.$store.dispatch('inventory/getAll');
    },
    async getSizes() {
      let tallas = await this.$store.dispatch('sizes/getData', this.production_model.model_id);
      this.sizes = tallas.data;
    },
    getIconClass(status) {
      if (status === 0) {
        return 'fa fa-circle'; // Ícono de clic
      } else if (status === 1) {
        return 'fa fa-check-circle text-success'; // Ícono de check verde
      } else if (status === 2) {
        return 'fa fa-times-circle text-danger'; // Ícono de X roja
      }
      return ''; // Devuelve una cadena vacía si no coincide con ningún estado
    },
    editRegisterNovelty(params) {
      this.novelty = params;
      this.openModalNovelty();
    },
    async deleteRegisterNovelty(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionNovelty/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getNovelties();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    openModalNovelty() {
      const modalElement = document.getElementById('ModalNovelty');
      this.modalNovelty = new Modal(modalElement); // Guarda la instancia del modal
      this.modalNovelty.show(); // Muestra el modal
    },
    closeModalNovelty() {
      if (this.modalNovelty) {
        this.modalNovelty.hide(); // Cierra el modal
      }
    },
    async submitFormNovelty() {
      try {
        this.novelty.production_id = this.form.id;
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("productionNovelty/save", this.novelty);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.novelty.total = 0;
              this.novelty.observation = '';

              this.closeModalNovelty();
              this.getNovelties();

            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },
    openModal(modulo) {
      this.production_user.modulo = modulo;
      // Asignar por defecto las unidades totales del módulo (cargue/descargue) al usuario
      this.production_user.received_quantity = this.getDefaultReceivedQuantityForModule(modulo);

      // Intentar asociar el production_id correcto según el módulo
      let productionId = null;
      const mod = Number(modulo);

      if (mod === 3) {
        // CARGUE: tomar el production_id desde el primer loading que tenga driying.production
        const firstLoading = (this.loadings || []).find(l => l?.driying?.production?.id);
        productionId = firstLoading?.driying?.production?.id || null;
      } else if (mod === 4) {
        // DESCARGUE: tomar el production_id desde el primer unloading que tenga modulo.driying.production
        const firstUnloading = (this.unloadings || []).find(u => u?.modulo?.driying?.production?.id);
        productionId = firstUnloading?.modulo?.driying?.production?.id || null;
      }

      this.production_user.production_id = productionId;
      this.form.production_id = productionId;

      const modalElement = document.getElementById('ModalUsers');
      this.ModalUsers = new Modal(modalElement); // Guarda la instancia del modal
      this.ModalUsers.show(); // Muestra el modal
      this.getOficios();

      // Reset filtros
      this.production_user.cuadrilla = '';
      this.production_user.oficio_id = 0;
      this.production_user.user_id = [];
      this.filteredUsers = [];
      this.userSearch = '';
      this.showUserSearch = false;
    },
    closeModal() {
      if (this.ModalUsers) {
        this.ModalUsers.hide(); // Cierra el modal
      }
    },
    openModalDrying() {
      this.calculateTotalQuantity();
      const modalElement = document.getElementById('ModalDrying');
      this.ModalDrying = new Modal(modalElement); // Guarda la instancia del modal
      this.ModalDrying.show(); // Muestra el modal
    },
    closeModalDrying() {
      if (this.ModalDrying) {
        this.ModalDrying.hide(); // Cierra el modal
      }
    },
    openModalLoading() {

      this.getDrying();

      const oven_id = this.loading.production_oven_id;

      const warehouse_id = this.loading.warehouse_id;



      this.loading = {
        id: 0,
        production_oven_id: oven_id,
        production_drying_id: 0,
        quantity: 0,
        burning_number: 0,
        averia_cargue: 0,
        averia_secado: 0,
        total_quantity: 0,
        warehouse_id: warehouse_id
      };



      setTimeout(() => {
        const modalElement = document.getElementById('ModalLoading');
        this.ModalLoading = new Modal(modalElement); // Guarda la instancia del modal
        this.ModalLoading.show(); // Muestra el modal
      }, 0);

    },
    closeModalLoading() {
      if (this.ModalLoading) {
        this.ModalLoading.hide(); // Cierra el modal
      }
    },
    openModalUnloading() {

      const production_id = this.unloading.production_oven_id;
      const warehouse_id = this.unloading.warehouse_id;
      const production_oven_id = this.unloading.production_oven_id;

      this.unloading = {
        id: 0,
        production_oven_id:production_oven_id,
        production_id: production_id,
        inventory_id: 0,
        primera: 0,
        segunda: 0,
        tercera: 0,
        quantity: 0,
        averia_descargue: 0,
        averia_crudo: 0,
        total_quantity: 0,
        warehouse_id: warehouse_id,
        details: [],
        warehouse_primera:'40',
        warehouse_segunda:'40',
        warehouse_tercera:'40',
      }

      const modalElement = document.getElementById('ModalUnloading');
      this.ModalUnloading = new Modal(modalElement); // Guarda la instancia del modal
      this.ModalUnloading.show(); // Muestra el modal
    },
    closeModalUnloading() {
      if (this.ModalUnloading) {
        this.ModalUnloading.hide(); // Cierra el modal
      }
    },


    openModalModel() {
      const modalElement = document.getElementById('ModalModel');
      this.modalModel = new Modal(modalElement); // Guarda la instancia del modal
      this.modalModel.show(); // Muestra el modal
    },
    closeModalModel() {
      if (this.modalModel) {
        this.modalModel.hide(); // Cierra el modal
      }
    },
    openModalDefects() {
      const modalElement = document.getElementById('ModalDefects');
      this.modalDefects = new Modal(modalElement); // Guarda la instancia del modal
      this.modalDefects.show(); // Muestra el modal
    },
    closeModalDefects() {
      if (this.modalDefects) {
        this.modalDefects.hide(); // Cierra el modal
      }
    },
    async getProductionUsers() {
      await this.$store.dispatch('productionUsers/getDataOven', this.form.id, 1);
      this.data = this.$store.state.productionUsers.getData;
      this.selectedOvenUserIds = [];
    },
    getCuadrillaName(row) {
      if (!row) return '—';
      // Prioridad 1: cuadrilla asignada en el registro de producción_usuario
      let cuadrillaId = row.cuadrilla;
      // Prioridad 2: cuadrilla que tenga el usuario en su ficha
      if ((cuadrillaId == null || cuadrillaId === '') && row.user && row.user.cuadrilla) {
        cuadrillaId = row.user.cuadrilla;
      }
      if (cuadrillaId == null || cuadrillaId === '') return '—';
      const c = (this.cuadrillas || []).find((q) => Number(q.id) === Number(cuadrillaId));
      return c ? (c.name || cuadrillaId) : cuadrillaId;
    },
    getAssignedUserNextAction(value) {
      if (value?.validated_date != null) return 'done';

      // Si no tiene inicio, siempre la siguiente acción es recibir/iniciar
      if (value?.received_date == null) return 'receive';

      const mod = Number(value?.modulo);

      // CARGUE (módulo 3) y DESCARGUE (módulo 4): cuando ya tiene fecha inicio y fecha término
      // (el operario recibió y entregó), solo queda la opción Validar.
      const hasReceived = value?.received_date != null && String(value.received_date).trim() !== '';
      const hasDelivered = value?.delivered_date != null && String(value.delivered_date).trim() !== '';
      if ((mod === 3 || mod === 4) && hasReceived && hasDelivered && value?.validated_date == null) {
        return 'validate';
      }

      // DESCARGUE (módulo 4): tiene inicio pero no término -> entregar
      if (mod === 4) {
        if (!hasDelivered) return 'deliver';
        return null;
      }

      // CARGUE (módulo 3) y resto: si no tiene fecha de entrega, siguiente acción es entregar
      if (!hasDelivered) return 'deliver';

      // Lógica por cantidades para módulo 3 cuando aún no tiene ambas fechas
      const deliveredQty = Number(value?.delivered_quantity || 0);
      const receivedQty = Number(value?.received_quantity || 0);
      if (deliveredQty < receivedQty) return 'deliver';
      if (value?.validated_date == null) return 'validate';
      return null;
    },
    isAssignedUserCheckboxDisabled(value) {
      if (this.form.status === 2) return true;
      if (value?.validated_date != null) return true;
      const selectedSet = new Set((this.selectedOvenUserIds || []).map(Number));
      const isSelected = selectedSet.has(Number(value?.id));
      if (isSelected) return false;
      if (!this.selectedBaseAction) return false;
      const action = this.getAssignedUserNextAction(value);
      return action !== this.selectedBaseAction;
    },
    // Reglas de habilitación de checkbox para usuarios de DESCARGUE
    isAssignedUserCheckboxDisabledDesc(value) {
      if (this.form.status === 2) return true;
      if (value?.validated_date != null) return true;
      const selectedSet = new Set((this.selectedOvenUserIds || []).map(Number));
      const isSelected = selectedSet.has(Number(value?.id));
      if (isSelected) return false;
      if (!this.selectedDescBaseAction) return false;
      const action = this.getAssignedUserNextAction(value);
      return action !== this.selectedDescBaseAction;
    },
    getSelectedAssignedUsers() {
      const rows = (this.data?.data || []).filter((v) => v.modulo === 3);
      const selectedSet = new Set((this.selectedOvenUserIds || []).map(Number));
      return rows.filter((r) => selectedSet.has(Number(r.id)));
    },
    getSelectedDescAssignedUsers() {
      const rows = (this.data?.data || []).filter((v) => v.modulo === 4);
      const selectedSet = new Set((this.selectedOvenUserIds || []).map(Number));
      return rows.filter((r) => selectedSet.has(Number(r.id)));
    },
    nowAsDbDateTime() {
      const now = new Date();
      const pad = (n) => String(n).padStart(2, '0');
      return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
    },
    /** Normaliza una fecha para enviar al API (Y-m-d H:i:s). */
    toApiDate(val) {
      if (val == null || val === '') return null;
      const d = new Date(val);
      if (isNaN(d.getTime())) return null;
      const pad = (n) => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    /** Arma el payload para productionUsers/save con solo campos que acepta el API y fechas en formato correcto. */
    buildProductionUserPayload(row, overrides = {}) {
      const base = {
        id: row.id,
        production_id: row.production_id ?? this.production_user.production_id ?? this.form.production_id ?? null,
        production_oven_id: row.production_oven_id ?? null,
        modulo: row.modulo,
        user_id: row.user_id ?? (row.user && row.user.id),
        oficio_id: row.oficio_id ?? null,
        cuadrilla: row.cuadrilla ?? null,
        received_quantity: Number(row.received_quantity) || 0,
        rejected_quantity: Number(row.rejected_quantity) || 0,
        delivered_quantity: Number(row.delivered_quantity) || 0,
        assigned_at: this.toApiDate(row.assigned_at) ?? null,
        received_date: this.toApiDate(row.received_date) ?? null,
        delivered_date: this.toApiDate(row.delivered_date) ?? null,
        validated_date: this.toApiDate(row.validated_date) ?? null,
        observation: row.observation ?? null,
        price: row.price != null ? Number(row.price) : 0,
      };
      return { ...base, ...overrides };
    },
    async markSelectedReceived() {
      if (this.form.status === 2) return;
      const selectedRows = this.getSelectedAssignedUsers();
      const eligible = selectedRows.filter((r) => r.received_date == null);
      if (eligible.length === 0) {
        await Swal.fire({ icon: 'info', title: 'Sin registros', text: 'Selecciona al menos un registro pendiente por iniciar.' });
        return;
      }
      const result = await Swal.fire({
        title: 'Marcar como recibido',
        text: `Se iniciará el trabajo para ${eligible.length} registro(s).`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;
      const fecha = this.nowAsDbDateTime();
      for (const row of eligible) {
        row.received_date = fecha;
        await this.$store.dispatch("productionUsers/save", row);
      }
      await Swal.fire({ icon: 'success', title: 'Listo', text: `Marcados como recibidos: ${eligible.length}` });
      await this.getProductionUsers();
    },
    async markSelectedReceivedDesc() {
      if (this.form.status === 2) return;
      const selectedRows = this.getSelectedDescAssignedUsers();
      const eligible = selectedRows.filter((r) => r.received_date == null);
      if (eligible.length === 0) {
        await Swal.fire({ icon: 'info', title: 'Sin registros', text: 'Selecciona al menos un registro pendiente por iniciar.' });
        return;
      }
      const result = await Swal.fire({
        title: 'Marcar como recibido',
        text: `Se iniciará el trabajo para ${eligible.length} registro(s).`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;
      const fecha = this.nowAsDbDateTime();
      for (const row of eligible) {
        row.received_date = fecha;
        await this.$store.dispatch("productionUsers/save", row);
      }
      await Swal.fire({ icon: 'success', title: 'Listo', text: `Marcados como recibidos: ${eligible.length}` });
      await this.getProductionUsers();
    },
    async markSelectedDelivered() {
      if (this.form.status === 2) return;
      const selectedRows = this.getSelectedAssignedUsers();
      const eligible = selectedRows.filter((r) =>
        r.received_date != null &&
        (r.delivered_date == null || (r.delivered_quantity < r.received_quantity))
      );
      if (eligible.length === 0) {
        await Swal.fire({ icon: 'info', title: 'Sin registros', text: 'Selecciona al menos un registro en progreso para finalizar.' });
        return;
      }
      const result = await Swal.fire({
        title: 'Marcar como entregado',
        text: `Se finalizará el trabajo para ${eligible.length} registro(s).`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;
      const fecha = this.nowAsDbDateTime();
      for (const row of eligible) {
        row.delivered_date = fecha;
        await this.$store.dispatch("productionUsers/save", row);
      }
      await Swal.fire({ icon: 'success', title: 'Listo', text: `Marcados como entregados: ${eligible.length}` });
      await this.getProductionUsers();
    },
    async markSelectedDeliveredDesc() {
      if (this.form.status === 2) return;
      const selectedRows = this.getSelectedDescAssignedUsers();
      const eligible = selectedRows.filter((r) =>
        r.received_date != null &&
        (r.delivered_date == null || (r.delivered_quantity < r.received_quantity))
      );
      if (eligible.length === 0) {
        await Swal.fire({ icon: 'info', title: 'Sin registros', text: 'Selecciona al menos un registro en progreso para finalizar.' });
        return;
      }
      const result = await Swal.fire({
        title: 'Marcar como entregado',
        text: `Se finalizará el trabajo para ${eligible.length} registro(s).`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;
      const fecha = this.nowAsDbDateTime();
      for (const row of eligible) {
        row.delivered_date = fecha;
        await this.$store.dispatch("productionUsers/save", row);
      }
      await Swal.fire({ icon: 'success', title: 'Listo', text: `Marcados como entregados: ${eligible.length}` });
      await this.getProductionUsers();
    },
    async markSelectedValidated() {
      if (this.form.status === 2) return;
      const selectedRows = this.getSelectedAssignedUsers();
      // CARGUE horno (módulo 3): solo exigir fecha entrega y sin validar (no cantidades)
      const eligible = selectedRows.filter((r) => {
        if (r.validated_date != null) return false;
        if (r.delivered_date == null) return false;
        const mod = Number(r.modulo);
        if (mod === 3) return true;
        return Number(r.delivered_quantity) >= Number(r.received_quantity);
      });
      if (eligible.length === 0) {
        await Swal.fire({
          icon: 'info',
          title: 'Sin registros',
          text: 'Selecciona al menos un usuario con fecha de entrega y sin validar (marca el check de la fila).',
        });
        return;
      }
      const { value: formValues } = await Swal.fire({
        title: 'Validar jornada',
        html: `
          <div style="text-align: left;">
              <div class="mb-3">
                <label for="swal-input-obs" class="form-label" style="font-weight: bold;">Observación (opcional):</label>
                <textarea id="swal-input-obs" class="form-control" placeholder="Agregue una observación" rows="3"></textarea>
              </div>
            </div>`,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonColor: '#28a745',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Validar',
        cancelButtonText: 'Cancelar',
        preConfirm: () => {
          const el = document.getElementById('swal-input-obs');
          return { obs: el ? el.value : '' };
        }
      });
      if (!formValues) return;
      const fecha = this.nowAsDbDateTime();
      const observation = (formValues.obs && String(formValues.obs).trim()) || '';
      try {
        for (const row of eligible) {
          const payload = this.buildProductionUserPayload(row, { validated_date: fecha, observation: observation || row.observation || '', finish: 1 });
          const response = await this.$store.dispatch("productionUsers/save", payload);
          if (response && response.status >= 400) {
            const msg = (response.data && (response.data.message || response.data.errors)) || 'Error al guardar la validación.';
            throw new Error(typeof msg === 'string' ? msg : JSON.stringify(msg));
          }
        }
        await Swal.fire({ icon: 'success', title: 'Jornada validada', text: `Validados: ${eligible.length}` });
        await this.getProductionUsers();
      } catch (err) {
        console.error(err);
        await Swal.fire({ icon: 'error', title: 'Error', text: err.message || 'No se pudo guardar la fecha de validación.' });
      }
    },
    async validateSingleDescUser(row) {
      if (this.form.status === 2) return;
      if (row.validated_date != null) return;
      try {
        const { value: formValues } = await Swal.fire({
          title: 'Validar tarea',
          html: `
            <div style="text-align: left;">
              <div class="mb-3">
                <label for="validation_note_single_desc">Observación (opcional)</label>
                <textarea id="validation_note_single_desc" class="form-control" rows="3" placeholder="Escribe una observación si es necesario"></textarea>
              </div>
            </div>
          `,
          focusConfirm: false,
          showCancelButton: true,
          confirmButtonText: 'Validar',
          cancelButtonText: 'Cancelar',
          preConfirm: () => {
            const note = (document.getElementById('validation_note_single_desc') || {}).value || '';
            return { note };
          },
        });
        if (!formValues) return;
        const fecha = this.nowAsDbDateTime();
        const observation = (formValues.note && String(formValues.note).trim()) || (row.observation || '');
        const payload = this.buildProductionUserPayload(row, { validated_date: fecha, observation, finish: 1 });
        const response = await this.$store.dispatch('productionUsers/save', payload);
        if (response && response.status >= 400) {
          const msg = (response.data && (response.data.message || response.data.errors)) || 'Error al guardar.';
          throw new Error(typeof msg === 'string' ? msg : JSON.stringify(msg));
        }
        await Swal.fire({ icon: 'success', title: 'Listo', text: 'Tarea validada correctamente.' });
        await this.getProductionUsers();
      } catch (err) {
        console.error(err);
        await Swal.fire({ icon: 'error', title: 'Error', text: err.message || 'Error al validar.' });
      }
    },
    async markSelectedValidatedDesc() {
      if (this.form.status === 2) return;
      const selectedRows = this.getSelectedDescAssignedUsers();
      // DESCARGUE (módulo 4): solo exigir fecha entrega y sin validar
      const eligible = selectedRows.filter((r) =>
        r.delivered_date != null &&
        r.validated_date == null
      );
      if (eligible.length === 0) {
        await Swal.fire({
          icon: 'info',
          title: 'Sin registros',
          text: 'Selecciona al menos un usuario con fecha de entrega y sin validar (marca el check de la fila).',
        });
        return;
      }
      const { value: formValues } = await Swal.fire({
        title: 'Validar jornada',
        html: `
          <div style="text-align: left;">
              <div class="mb-3">
                  <label for="validation_note_desc" class="form-label" style="font-weight: bold;">Observación (opcional):</label>
                  <textarea id="validation_note_desc" class="form-control" rows="3" placeholder="Escribe una observación si es necesario"></textarea>
              </div>
          </div>
        `,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: 'Validar',
        cancelButtonText: 'Cancelar',
        preConfirm: () => {
          const note = (document.getElementById('validation_note_desc') || {}).value || '';
          return { note };
        },
      });
      if (!formValues) return;
      const fecha = this.nowAsDbDateTime();
      const observation = (formValues.note && String(formValues.note).trim()) || '';
      try {
        for (const row of eligible) {
          const payload = this.buildProductionUserPayload(row, { validated_date: fecha, observation: observation || row.observation || '', finish: 1 });
          const response = await this.$store.dispatch("productionUsers/save", payload);
          if (response && response.status >= 400) {
            const msg = (response.data && (response.data.message || response.data.errors)) || 'Error al guardar la validación.';
            throw new Error(typeof msg === 'string' ? msg : JSON.stringify(msg));
          }
        }
        await Swal.fire({ icon: 'success', title: 'Listo', text: `Marcados como validados: ${eligible.length}` });
        await this.getProductionUsers();
      } catch (err) {
        console.error(err);
        await Swal.fire({ icon: 'error', title: 'Error', text: err.message || 'No se pudo guardar la fecha de validación.' });
      }
    },
    async getInsumos() {
      const data = await this.$store.dispatch('productionModels/getData', this.form.id);
      this.insumos = data.data;
    },
    async getAllInsumos() {
      this.insumosInventory = await this.$store.dispatch('inventory/getAll');
    },
    async save() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const payload = { ...this.form };
        if (!payload.production_models_id) {
          delete payload.production_models_id;
        }
        // Asegurar que user_id sea un entero válido
        if (!payload.user_id) {
          const storedUser = JSON.parse(localStorage.getItem('user') || 'null');
          if (storedUser && storedUser.id) {
            payload.user_id = Number(storedUser.id);
          }
        } else {
          payload.user_id = Number(payload.user_id);
        }
        const response = await this.$store.dispatch("productionOven/save", payload);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El proyecto ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.form.id = response.data.id;

              this.furnaceBurn.production_oven_id = this.form.id || 0;
              this.loading.warehouse_id = this.form.oven_id || 0;
              this.unloading.warehouse_id = this.form.oven_id || 0;
              this.loading.production_oven_id = this.form.id || 0;

              this.unloading.production_oven_id = this.form.id || 0;

              this.production_user.production_oven_id = this.form.id || 0;

            }
          });

        } else {
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        console.error("Error al crear el proyecto:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el proyecto',
        });
      }
    },
    async submitForm() {
      if (this.isSubmittingAssignUsers) return;
      this.isSubmittingAssignUsers = true;

      try {
        // Determinar cantidad total directamente desde la API según el módulo (cargue/descargue),
        // sin depender del estado local de this.loading / this.unloading.
        let qty = 0;
        const modulo = Number(this.production_user.modulo);

        if (modulo === 3) {
          // CARGUE: obtener registros de production_loading asociados al horno actual
          const loadings = await this.$store.dispatch("productionLoading/getData", this.form.id);
          if (Array.isArray(loadings) && loadings.length > 0) {
            const last = loadings[loadings.length - 1];
            qty = Number(last?.total_quantity ?? last?.quantity ?? 0) || 0;
          }
        } else if (modulo === 4) {
          // DESCARGUE: obtener registros de production_unloading asociados al horno actual
          const unloadings = await this.$store.dispatch("productionUnloading/getData", this.form.id);
          if (Array.isArray(unloadings) && unloadings.length > 0) {
            const last = unloadings[unloadings.length - 1];
            qty = Number(last?.total_quantity ?? last?.quantity ?? 0) || 0;
          }
        } else {
          // Otros módulos: conservar la cantidad ya configurada en la asignación
          qty = Number(this.production_user.received_quantity ?? 0) || 0;
        }

        const payload = {
          ...this.production_user,
          production_id: this.production_user.production_id || this.form.production_id || null,
          received_quantity: qty,
        };

        const response = await this.$store.dispatch("productionUsers/save", payload);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.getProductionUsers();
              this.closeModal();

              this.production_user.oficio_id = 0;
              this.production_user.user_id = [];
              this.production_user.received_quantity = 0;
              this.production_user.price = 0;
              this.production_user.delivered_quantity = 0;


              $(this.$refs.modelUserSelect).val(null).trigger('change');
              $(this.$refs.processesSelect).val(null).trigger('change');
              $(this.$refs.usersSelect).val(null).trigger('change');

            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      } finally {
        this.isSubmittingAssignUsers = false;
      }

    },
    async submitFormModel() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("productionModels/save", this.production_model);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.production_model.model_id = 0;
              this.production_model.size_id = 0;
              this.production_model.quantity_to_produce = 0;
              this.production_model.price = 0;

              $(this.$refs.modelSelect).val(null).trigger('change');
              $(this.$refs.sizesSelect).val(null).trigger('change');


              this.getInsumos();
              this.closeModalModel();


            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },
    async deleteRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionModels/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getInsumos();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    viewObservation(observation) {
      // Mostramos el mensaje en un SweetAlert
      Swal.fire({
        title: 'Observación',
        text: observation || 'No hay observaciones disponibles.',
        icon: 'info',  // Puedes cambiar el icono a info, success, warning, etc.
        confirmButtonText: 'Aceptar'
      });
    },
    async checkReceived(value) {

      try {
        const result = await Swal.fire({
          title: 'Iniciar trabajo',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, aceptar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {

          const now = new Date();
          const pad = n => String(n).padStart(2, '0');

          value.received_date = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;

          const response = await this.$store.dispatch("productionUsers/save", value);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Trabajo iniciado!',
              'Recuerda finalizar la jornada.',
              'success'
            );

            this.getProductionUsers();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },

    async checkDelivered(value) {

      try {
        const result = await Swal.fire({
          title: 'Finalizar trabajo',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, aceptar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {

          const now = new Date();
          const pad = n => String(n).padStart(2, '0');

          value.delivered_date = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;

          const response = await this.$store.dispatch("productionUsers/save", value);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Trabajo finalizado!',
              'El registro se ha guardado correctamente.',
              'success'
            );

            this.getProductionUsers();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },

    async checkValidated(value) {

      try {

        const { value: formValues } = await Swal.fire({
          title: 'Validar jornada',
          html: `
          <div style="text-align: left;">
              <div class="mb-3">
                <label for="swal-input-cant" class="form-label" style="font-weight: bold;">Validar jornada del trabajador</label>
              </div>
              <div class="mb-3">
                <label for="swal-input-obs" class="form-label" style="font-weight: bold;">Observación:</label>
                <textarea id="swal-input-obs" class="form-control" placeholder="Agregue una observación" rows="3"></textarea>
              </div>
            </div>`,
          focusConfirm: false,
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, aceptar!',
          cancelButtonText: 'Cancelar',
          preConfirm: () => {
            return {
              obs: document.getElementById('swal-input-obs').value
            };
          }
        });

        if (formValues) {

          const now = new Date();
          const pad = n => String(n).padStart(2, '0');

          value.validated_date = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;

          value.observation = formValues.obs;
          value.finish = 1;

          const response = await this.$store.dispatch("productionUsers/save", value);

          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire(
              'Jordada validada!',
              'Excelente trabajo.',
              'success'
            );
            this.getProductionUsers();
          } else {
            this.getProductionUsers();
            throw new Error(response.data.message || 'Error al guardar el registro');
          }
        }
      } catch (error) {
        console.error("Error al guardar el registro:", error);


        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });



      }
    },
    async checkValidatedOld(value) {
      try {
        const { value: cant } = await Swal.fire({
          title: 'Validar Tarea',
          html: `
        <div style="text-align: left;">
          <div class="mb-3">
            <label for="swal-input-defect" class="form-label" style="font-weight: bold;">Cantidad con defectos:</label>
            <input id="swal-input-defect" type="number" class="form-control" placeholder="Cantidad con defectos" min="0">
          </div>
        </div>
      `,
          focusConfirm: false,
          preConfirm: () => {
            const defectInput = document.getElementById('swal-input-defect').value;
            const defectValue = Number(defectInput); // Convertir a número

            if (isNaN(defectValue) || defectValue < 0) {
              Swal.showValidationMessage('Debe ingresar una cantidad válida.');
              return false;
            }

            if (defectValue > Number(value.received_quantity)) {
              Swal.showValidationMessage('La cantidad supera la asignada.');
              return false;
            }

            return defectValue; // Retorna el valor válido
          },
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
        });

        if (cant !== undefined) {
          value.validated_date = new Date().toISOString().slice(0, 10);
          value.rejected_quantity = cant;
          value.finish = 1;

          const response = await this.$store.dispatch("productionUsers/save", value);
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire('Tarea Validada!', 'Excelente trabajo.', 'success');
            this.getProductionUsers();
            this.getInsumos();
          } else {
            throw new Error(response.data.message || 'Error al guardar el registro');
          }
        }
      } catch (error) {
        console.error("Error al guardar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    }
    ,
    async deleteUserRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionUsers/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getProductionUsers();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },

  },
  async mounted() {

    $(".select-tags").select2({
        tags: true,
        tokenSeparators: [',', ' ']
    })

    $(this.$refs.cuadrillaSelect).select2({
      placeholder: 'Todas',
      allowClear: true,
    }).on('change', () => {
      this.production_user.cuadrilla = $(this.$refs.cuadrillaSelect).val();
      this.userSearch = '';
      this.showUserSearch = false;
      this.filterUsersByOficioAndCuadrilla();
    });

    const today = new Date();
    this.form.started_at = today.toISOString().slice(0, 10);

    // Sumar 5 días
    const estimatedDate = new Date(today);
    estimatedDate.setDate(today.getDate() + 5);
    this.form.estimated_at = estimatedDate.toISOString().slice(0, 10);


    for (let i = 0; i < 4; i++) {
      const ref = this.$refs[`collapse${i}`]
      if (ref) {
        this.bsCollapse[i] = new Collapse(ref, { toggle: false })
        // Track open/close for conditional action buttons
        ref.addEventListener('shown.bs.collapse', () => { this.collapseOpen[i] = true })
        ref.addEventListener('hidden.bs.collapse', () => { this.collapseOpen[i] = false })
      }
    }

   
    this.getDrying();
    this.getOficios();
    this.getCuadrillas();
    this.getUsers();
    this.getMaterials();

    await this.getModels();
    await this.getBodegas();

    this.$nextTick(() => {

       const dataEdit = this.route.params.data;

      // Agregar las opciones dinámicamente
      const $select = $(this.$refs.modelSelect);
      $select.empty().append('<option value="">Seleccionar horno</option>');
      // Mostrar todos los hornos (tipo 2), aceptando tipo como número o string; al agregar se muestran también los ocupados (status 1)
      const hornos = (this.bodegas || []).filter(h => Number(h.tipo) === 2);
      hornos.forEach(model => {
        const label = model.status == 1 ? `${model.name} (Ocupado)` : model.name;
        $select.append(new Option(label, model.id));
      });
      $(this.$refs.modelSelect).select2({
        placeholder: 'Seleccione un horno',
        allowClear: false,
      }).on('change', () => {
        this.form.oven_id = $(this.$refs.modelSelect).val();
      });

      $(this.$refs.processesSelect).select2({
        placeholder: 'Seleccione un oficio',
        allowClear: true,
      }).on('change', () => {
        this.production_user.oficio_id = $(this.$refs.processesSelect).val();
        // El oficio se guarda para el registro, pero la lista de usuarios se filtra por Cargo + Cuadrilla
      });
      $(this.$refs.processesSelect).val(null).trigger('change');

     

      try {
        // Si hay datos para editar, cargarlos
        if (dataEdit) {
          const params = JSON.parse(dataEdit);
          this.data = params;
          if (params && params.id) {

            //Formulario principal
            this.form.id = params.id || 0;
            this.form.consecutive = String(params.consecutive) || '';
            this.form.consecutivo_secado = String(params.consecutivo_secado) || '';
            this.form.user_id = params.user_id || '';
            this.form.oven_id = params.oven_id || '';
            this.form.burn_number = params.burn_number || '';
            this.form.started_at = params.started_at || '';
            this.form.estimated_at = params.estimated_at || '';
            this.form.finished_at = params.finished_at || '';
            this.form.finished_user_id = params.finished_user_id || '';
            this.form.production_models_id = params.production_models_id || 0;
            this.form.status = (params.status !== undefined && params.status !== null && params.status !== '') ? Number(params.status) : 0;

            this.furnaceBurn.production_oven_id = params.id || 0;

            $(this.$refs.modelSelect).val(this.form.oven_id).trigger('change');

            this.getProductionUsers();

            this.getLoadings();

            this.getUnloadings();

            this.getFurnace();

            this.production_user.production_oven_id = params.id || null;
            this.production_user.production_models_id = params.production_models_id || 0;

            this.furnaceBurn.oven_id = params.id || 0;

            this.loading.warehouse_id = params.oven_id || 0;
            this.loading.production_oven_id = params.id || '';

            this.unloading.warehouse_id = params.oven_id || 0;
            this.unloading.production_oven_id = params.id || 0;
            

          }

        }

        // Cerrar el modal de carga
        Swal.close();
      } catch (error) {
        // Manejo de errores
        console.error("Error al cargar los datos:", error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Hubo un problema al cargar los datos. Por favor, inténtalo nuevamente.',
        });
      }

    });
    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {

    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.disabled-link {
  color: gray;
  pointer-events: none;
  /* Impide la interacción */
  cursor: not-allowed;
  /* Cambia el cursor para indicar que está deshabilitado */
}

.section-title {
  font-weight: 800;
  color: #1f2d5a;
  letter-spacing: 0.6px;
}

.section-title::after {
  content: "";
  display: block;
  width: 44px;
  height: 3px;
  margin-top: 6px;
  border-radius: 999px;
  background: #f6a500;
}

/* Forzar estilo en títulos dentro de card-body (ej. USUARIOS ASIGNADOS) */
.card-body .section-title,
.mb-2 .section-title {
  font-weight: 800 !important;
  color: #1f2d5a !important;
  letter-spacing: 0.6px;
}
.card-body .section-title::after,
.mb-2 .section-title::after {
  content: "";
  display: block;
  width: 44px;
  height: 3px;
  margin-top: 6px;
  border-radius: 999px;
  background: #f6a500;
}

.modal-title-underline::after {
  content: "";
  display: block;
  width: 44px;
  height: 3px;
  margin-top: 6px;
  border-radius: 999px;
  background: #f6a500;
}

.card-border-blue {
  border: 2px solid #1f2d5a !important;
  border-radius: 0.375rem;
}

/* Fila CREAR QUEMA + QUEMAS EN HORNO: altura limitada para que el panel derecho haga scroll */
.oven-panels-row {
}
.oven-panels-row > [class*="col-"] {
  min-height: 0;
}
/* Panel QUEMAS EN HORNO: scroll cuando no caben todas las tarjetas */
.oven-quemas-col {
  min-height: 0;
}
.oven-quemas-card {
  min-height: 0;
  display: flex !important;
  flex-direction: column !important;
}
.oven-quemas-body {
  overflow-y: auto !important;
  min-height: 0 !important;
  flex: 1 1 0 !important;
  -webkit-overflow-scrolling: touch;
}
.oven-quemas-body::-webkit-scrollbar {
  width: 6px;
}
.oven-quemas-body::-webkit-scrollbar-thumb {
  background: rgba(31, 45, 90, 0.25);
  border-radius: 999px;
}

/* Tarjetas QUEMAS EN HORNO: etiquetas azules, valores alineados */
.furnace-card-info { font-size: 0.75rem; }
.furnace-card-row { min-height: 1.25rem; }
.furnace-card-label {
  color: #1f2d5a;
  font-weight: 600;
  min-width: 10rem;
  flex-shrink: 0;
}
.furnace-card-label-inline {
  color: #1f2d5a !important;
  font-weight: 600;
}
.furnace-card-label-fixed {
  min-width: 5.5rem;
  flex-shrink: 0;
}
.furnace-card-value {
  color: #344767;
  font-weight: 500;
}
.furnace-card-sublabel,
.furnace-card-info .furnace-card-sublabel {
  color: #1f2d5a !important;
  font-size: 0.7rem;
  line-height: 1;
}
.furnace-card-grid {
  display: grid;
  /* Primera columna: P1/P2 un poco a la derecha para alinear con íconos de reloj */
  grid-template-columns: 10rem 1fr;
  gap: 0.5rem 1rem;
  align-items: start;
}
.furnace-card-grid-cell {
  min-width: 0;
}

.furnace-input-group .form-control {
  border-right: 0;
}

.furnace-input-group .input-group-text {
  border-left: 0;
  background-color: #fff;
}

.furnace-input-group:focus-within .form-control,
.furnace-input-group:focus-within .input-group-text {
  border-color: #f6a500;
}

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.custom-checkbox-wrapper-assigned {
  display: flex;
  align-items: center;
}

.custom-checkbox {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.custom-checkbox-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1.5px solid #6c757d;
  background-color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  margin: 0;
}

.custom-checkbox-label i {
  font-size: 10px;
  color: transparent;
  transition: color 0.2s ease;
}

.custom-checkbox:checked + .custom-checkbox-label {
  background-color: #28a745;
  border-color: #28a745;
}

.custom-checkbox:checked + .custom-checkbox-label i {
  color: white;
}

.custom-checkbox:hover + .custom-checkbox-label {
  border-color: #28a745;
}

.custom-checkbox:disabled + .custom-checkbox-label {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
